import EmployeeResourcesModal from '../components/EmployeeResourcesModal';
import { getProjectEndDate } from '../services/duration';
import React, { useState, useEffect, Children } from 'react';
import HubSpot from '../components/HubSpot';
import { SaveOutlined, DeliveredProcedureOutlined, LoadingOutlined, CheckCircleOutlined, InfoCircleOutlined, EditOutlined, DollarOutlined, CopyOutlined } from '@ant-design/icons';
import { Row, FloatButton, Drawer, Card, Badge, InputNumber, Select, Modal, Input, Checkbox, message, Spin, Table, Tooltip, Segmented, Button } from 'antd';
import DealEconomicsSummaries from '../components/DealEconomicsSummaries';
import { currencySymbolsMap, useCurrency } from '../../context/CurrencyContext';
import ParticipantsAndRates from '../components/ParticipantsAndRates';
import ResourceAllocationPlan from '../components/ResourceAllocationPlan';
import NonResourceCosts from '../components/NonResourceCosts';
import ProjectRevenue from '../components/ProjectRevenue';
import SummaryTable from '../components/Summary';
import RevenueSummary from '../components/RevenueSummary';
import DealEconomicsSummariesDetails from '../components/DealEconomicsSummariesDetails';
import getMonthlyWorkingHours from '../hooks/MonthlyHoursCalculation';
import { HubSpotData, ResourceAllocationPlanTable, ParticipantsAndRatesTable, NonResourcePricingTable, RevenueData, LineItem, HubspotField, ResourceRequestConfirmation, ResourceRequestPreview } from '../interfaces/interfaces';
import dayjs from 'dayjs';
import { getHubspotDealDetails, getPricingContributors, getPricingVersion, getDealVersionDetails, getPricingCalculatorDetails, getNonResourcePricingDetails, getWorkHours, savePricingDealVersion, getDiscountTargetMarginDD, updatePricingDealVersionName, getPricingDealVersions, getPricingDealVersionCount, getLoggedInUserDetails, getLatestLineItems, updateHubspotLineItems, refreshDeals, getPricingCalculatorVersionList, lockPricingDeal } from '../../services/Apis';
import { useNavigate, useSearchParams } from 'react-router-dom';
import LogoutPopUp from '../../components/LogoutPopUp';
import LineItemCompareTable from '../components/HubSpotLineItem';
import { addOrSubtractDays, addOrSubtractDaysForEndDate, calculateDaysBetweenDates, calculateEndDate, calculateStartDate, changeDiscountAmount, changeDiscountValue, changeTotalAmount, checkStartDateAndDuration, roundOffMonthlyValues, validateInputs } from '../services/services';
import HubspotFieldsChangeTable from '../components/HubspotFieldsChangeTable';
import { getTooltip } from '../services/tooltip_services';
import DealInsights from '../components/DealInsights';
import NoAccessPopup from '../../components/NoAccessPopup';
import CreateTemplateModal from '../components/CreateTemplateModal';
import cleanResourceRequestList from '../services/cleanResourceList';
import cleanUiResourceRequestList from '../services/cleanUiResourceList';
import CopyDealResourcesModal from '../components/CopyDealResourcesModal';
import ResourceRequestMappingModal from '../components/ResourceRequestMappingModal';

interface EditPricingDetailsProps {
  viewOnly?: boolean
}

const normalizeErrorMessage = (error: unknown): string => {
  if (error == null) return '';
  if (typeof error === 'string') return error;
  if (error instanceof Error) return error.message;
  if (Array.isArray(error)) {
    return error.map(normalizeErrorMessage).filter(Boolean).join(', ');
  }
  if (typeof error === 'object') {
    const errorObject = error as Record<string, unknown>;
    const nestedError = errorObject.detail ?? errorObject.message ?? errorObject.error ?? errorObject.errors;
    if (nestedError != null && nestedError !== error) {
      return normalizeErrorMessage(nestedError);
    }
    try {
      return JSON.stringify(error);
    } catch {
      return 'Unknown error occurred';
    }
  }
  return String(error);
};

const { TextArea } = Input;

const EditPricingDetails: React.FC<EditPricingDetailsProps> = ({ viewOnly = false }) => {

  const navigate = useNavigate();
  const [searchParams] = useSearchParams(); // Get search params from the URL
  // Use the currency context
  const { dealCurrency, currencySymbol, updateCurrency } = useCurrency();
  const [open, setOpen] = useState(false);
  const [dealAllVersionsEconomicsSummaries, setDealAllVersionsEconomicsSummaries] = useState<any[]>([]);
  const [dealAllVersionsHeaderList, setDealAllVersionsHeaderList] = useState<any[]>([]);
  const [versionCount, setVersionCount] = useState(0);
  const [startDate, setStartDate] = useState(dayjs('2024-09-15'));
  const [duration, setDuration] = useState(6);
  const [endDate, setEndDate] = useState(getProjectEndDate('2024-09-15', duration));

  const dealId = Number(searchParams.get('dealId'));
  const [versionName, setVersionName] = useState(searchParams.get('versionName') || '');
  const isOdeLockRecovery = searchParams.get('retryOdeLock') === '1';
  const [newVersionName, setNewVersionName] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [errorArray, setErrorArray] = useState<any[]>([]);
  const [sendEmail, setSendEmail] = useState(false);
  const [sendHubspotLineItems, setSendHubspotLineItems] = useState(false);
  const [updateHubspotDealAmount, setUpdateHubspotDealAmount] = useState(false);
  const [showHubspotLineItemsUpdatedMessage, setShowHubspotLineItemsUpdatedMessage] = useState(false);

  const [hubspotDropdownDetails, setHubspotDropdownDetails] = useState<any>(null);
  // ParticipantsAndRates
  const [ParticipantsAndRatesData, setParticipantsAndRatesData] = useState<ParticipantsAndRatesTable[]>([]);
  const [ParticipantsAndRatesInitialData, setParticipantsAndRatesInitialData] = useState<ParticipantsAndRatesTable[]>([]);
  // Non-Resource costs
  const [nonResourceData, setNonResourceData] = useState<NonResourcePricingTable[]>([]);
  const [nonResourceInitialData, setNonResourceInitialData] = useState<NonResourcePricingTable[]>([]);
  const [nonResourcePricingDetails, setNonResourcePricingDetails] = useState<any>(null);
  const [dealEconomicsFinalData, setDealEconomicsFinalData] = useState<any[]>([]);
  const [monthlyHours, setMonthlyHours] = useState<any[]>([]);
  const [isDealLocked, setIsDealLocked] = useState<boolean>(false)
  const [lockOde, setlockOde] = useState<boolean>(false)
  const [retryingOdeLock, setRetryingOdeLock] = useState<boolean>(false)
  const [enabledFeatureList, setEnabledFeatureList] = useState<string[]>([])
  const [isHubspotFieldsChanged, setIsHubspotFieldsChanged] = useState<boolean>(false)
  const [hubspotFieldsChangedArray, setHubspotFieldsChangedArray] = useState<HubspotField[]>([])
  const [lineItems, setLineItems] = useState<LineItem[]>([]);
  const [updatedPricingItems, setUpdatedPricingItems] = useState<LineItem[]>([]);
  const [loader, setLoader] = useState(false);
  const [basePricingloader, setBasePricingLoader] = useState(false);
  const [fatalError, setFatalError] = useState<string | null>(null);
  const [isRedirectToHome, setIsRedirectToHome] = useState(false);
  const [dealTotalAmount, setDealTotalAmount] = useState<number>(0);
  const [additionalResourcingInfo, setAdditionalResourcingInfo] = useState<string>("")
  const [minFTEWarning, setMinFTEWarning] = useState<boolean>(false);
  const [hoveredRowKey, setHoveredRowKey] = useState<number | null>(null);
  const [copyResourcesOpen, setCopyResourcesOpen] = useState<false | 'deal' | 'employee'>(false);
  const ResourceImportModal = copyResourcesOpen === 'employee' ? EmployeeResourcesModal : CopyDealResourcesModal;

  // State for HubSpot deal details
  const [HubspotDealData, setHubspotDealData] = useState<any>(null);
  
  // Effect to update currency when HubspotDealData loads
  useEffect(() => {
    if (HubspotDealData && HubspotDealData.currency) {
      updateCurrency(HubspotDealData.currency);
    }
  }, [HubspotDealData, updateCurrency]);
  
  const [PricingContributors, setPricingContributors] = useState<any>(null);
  const [pricingCollaborators, setPricingCollaborators] = useState<any>(null);
  const [PricingVersion, setPricingVersion] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [versionId, setVersionId] = useState<number>(1);
  const [pricingCalculatorDetails, setPricingCalculatorDetails] = useState<any>(null);
  const [workHours, setWorkHours] = useState<any>(null);
  const [tokenExpired, setTokenExpired] = useState<boolean>(false);
  const [discountValue, setDiscountValue] = useState<number>(0);
  const [discountAmount, setDiscountAmount] = useState<number>(0);
  const [dealPricingComment, setDealPricingComment] = useState<string>('');
  const [belowTargetMarginReason, setBelowTargetMarginReason] = useState<string>('');
  const [discountRationale, setDiscountRationale] = useState<string>("");
  const [contingencyValue, setcontingencyValue] = useState<number>(0);
  const [dealEconomicsSummaries, setDealEconomicsSummaries] = useState<any>([]);
  const [dealEconomicsGrossNetSummaries, setDealEconomicsGrossNetSummaries] = useState<any>([]);
  const [targetMarginDD, setTargetMarginDD] = useState<any>(null);
  const [discountRationaleDD, setDiscountRationaleDD] = useState<any>(null);
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState<boolean>(false);
  const [savePricingLoader, setSavePricingLoader] = useState<boolean>(false);
  const [newVersionNameModalVisible, setNewVersionNameModalVisible] = useState<boolean>(false);
  const [versionNameInputVisible, setVersionNameInputVisible] = useState<boolean>(false);
  const [saveNewPricingVersion, setSaveNewPricingVersion] = useState<boolean>(false);
  const [reloadNavigation, setReloadNavigation] = useState<boolean>(false);
  const [isDealVersionDetailsLoaded, setIsDealVersionDetailsLoaded] = useState<boolean>(false);
  const [distinctServiceLines, setDistinctServiceLines] = useState<string[]>([]);
  const [ResourceAllocationPlanData, setResourceAllocationPlanData] = useState<ResourceAllocationPlanTable[]>([]);
  const [ResourceFinalAllocationPlanData, setResourceFinalAllocationPlanData] = useState<ResourceAllocationPlanTable[]>([]);
  const [revenueData, setRevenueData] = useState<RevenueData[]>([]);
  const [monthlySummaryData, setMonthlySummaryData] = useState<any[]>([]);
  const [monthlySummaryDataAfterDiscount, setMonthlySummaryDataAfterDiscount] = useState<any[]>([]);
  const [servicelineTotalRevenue, setServiceLineTotalRevenue] = useState<any[]>([]);
  const [dealLastRefreshedOn, setDealLastRefereshedOn] = useState<any>([]);
  const [refreshingDeal, setRefreshingDeal] = useState<boolean>(false);
  const [existingMonthlyAllocation, setExistingMonthlyAllocation] = useState<number>(0);
  const [requestODELock, setRequestODELock] = useState<boolean>(false)
  const [resourceRequestPreview, setResourceRequestPreview] = useState<ResourceRequestPreview | null>(null)
  const [resourceMappingModalOpen, setResourceMappingModalOpen] = useState<boolean>(false)
  const [confirmCancelOpen, setConfirmCancelOpen] = useState<boolean>(false)
  const [createTemplateModalVisible, setCreateTemplateModalVisible] = useState<boolean>(false)
  const [noAccess, setNoAccess]= useState<boolean>(false)
  const [pipelineName, setPipelineName] = useState<string>('')
  const [useOldWorkhours, setUseOldWorkhours] = useState<string>('')



  const handleBasePricingChange = async (data: any[]) => {
    setHubspotDropdownDetails(data[0]);
    if (versionId !== data[0].base_price_version_id) {
      setBasePricingLoader(true);
      setVersionId(data[0].base_price_version_id);
      const pricingCalculatorDetailsDataPromise: any = getPricingCalculatorDetails(dealId, data[0].base_price_version_id);
      const workingHoursPromise = getWorkHours(dealId, data[0].base_price_version_id);
      const pricingCalculatorDetailsResponse: any = await pricingCalculatorDetailsDataPromise;
      const pricingCalculatorDetailsData: any[] = Array.isArray(pricingCalculatorDetailsResponse)
        ? pricingCalculatorDetailsResponse
        : [];
      const nonResourcePricingDetailsPromise: any = getNonResourcePricingDetails(dealId, data[0].base_price_version_id);
      const workingHours = await workingHoursPromise;
      const nonResourcePricingDetailsData: any = await nonResourcePricingDetailsPromise;
      setNonResourcePricingDetails(Array.isArray(nonResourcePricingDetailsData) ? nonResourcePricingDetailsData : []);
      const monthlyHours = getMonthlyWorkingHours(startDate.format('YYYY-MM-DD'), duration, workingHours, existingMonthlyAllocation);
      setMonthlyHours(monthlyHours);
      const resourceData = JSON.parse(JSON.stringify(ParticipantsAndRatesData))
      const distinctServiceLines: string[] = Array.from(new Set(pricingCalculatorDetailsData.map((obj: any) => obj.service_line)));
      const distinctRegions: string[] = Array.from(new Set(pricingCalculatorDetailsData.map((obj: any) => obj.region)));
      const distinctCareerLevels: string[] = Array.from(new Set(pricingCalculatorDetailsData.map((obj: any) => obj.career_level)));
      const distinctFunctions: string[] = Array.from(new Set(pricingCalculatorDetailsData.map((obj: any) => obj.function)));
      const distinctResourceTypes: string[] = Array.from(new Set(pricingCalculatorDetailsData.map((obj: any) => obj.resource_type)));
      const resourceCleanData = cleanUiResourceRequestList(resourceData, {
        resourceTypes: distinctResourceTypes,
        selectRegions: distinctRegions,
        serviceLineCapabilities: distinctServiceLines,
        functions: distinctFunctions,
        selectLevels: distinctCareerLevels
      });
      setPricingCalculatorDetails(pricingCalculatorDetailsData);
      setParticipantsAndRatesInitialData(resourceCleanData.map((item: any) => {
        const lookUpValues = pricingCalculatorDetailsData.filter((data: any) => data.resource_type === item.resourceType && data.region === item.selectRegion && data.service_line === item.serviceLineCapability && data.career_level === item.selectLevel && data.function === item.function)[0];
        const loadedLaborCostHr = lookUpValues?.cost_per_hour ?? item.loadedLaborCostHr;
        const targetClientMargin = lookUpValues?.target_client_margin ? Number((lookUpValues?.target_client_margin * 100).toFixed(2)) : item.targetClientMargin;
        const minFTE = lookUpValues?.min_fte_allocation ?? 0;
        return {
          'key': item.key,
          'oldKey': item.oldKey ?? item.key,
          'resourceType': item.resourceType,
          'selectRegion': item.selectRegion,
          'serviceLineCapability': item.serviceLineCapability,
          'function': item.function,
          'selectLevel': item.selectLevel,
          'loadedLaborCostHr': loadedLaborCostHr,
          'targetClientMargin': targetClientMargin,
          'proposedPriceHr': item.proposedPriceHr,
          'targetPriceHr': Number(((loadedLaborCostHr * 100) / (100 - targetClientMargin)).toFixed(2)),
          'clientMarginProposed': Number((100 - ((100 * loadedLaborCostHr) / (item.proposedPriceHr))).toFixed(2)),
          'varianceTargetMargin': (Number((100 - ((100 * loadedLaborCostHr) / (item.proposedPriceHr))).toFixed(2))) - targetClientMargin,
          'minFTE': minFTE,
          'resourceRequirementId': item.resourceRequirementId
        }
      }))
      const newdistinctServiceLines: string[] = Array.from(new Set(pricingCalculatorDetailsData.map((obj: any) => obj.service_line)));
      setDistinctServiceLines([...newdistinctServiceLines, "Contingency"]);
      setBasePricingLoader(false);
    }

  };

  const handleVersionNameUpdate = async (data: any[]) => {
    const updateResponse = await updatePricingDealVersionName(dealId, data[0].versionName, data[0].newVersionName.trim());
    if (updateResponse.error_status === 401) {
      setTokenExpired(true);
    } else {
      if (updateResponse.error) {
        console.error('Error Response Data:', updateResponse.error);
        console.error('Error Response Status:', updateResponse.error_status);
        setError(normalizeErrorMessage(updateResponse.error));
      } else {
        navigate(`/edit-pricing-details?dealId=${dealId}&versionName=${encodeURIComponent(data[0].newVersionName.trim())}`);  // Navigate to /edit-pricing page
        setVersionName(data[0].newVersionName.trim());
        setError(null);
      }
    }
  };

  const handleParticipantsAndRatesCallback = (data: ParticipantsAndRatesTable[]) => {
    if (data.length === 0) {
      setRevenueData([])
      setMonthlySummaryData([])
      setMonthlySummaryDataAfterDiscount([])
      setServiceLineTotalRevenue([])
      setResourceFinalAllocationPlanData([])
    }
    const newData =  data.map((item: any,index:number) => {
      const newItem = {...item}
      newItem.key = index + 1
      return newItem
    })
    setParticipantsAndRatesData(newData);
    const idDataComplete = Object.values(data).every(value => value !== null && value !== undefined);

  };

  const handleNonResourceCallback = (data: NonResourcePricingTable[]) => {
    const newData = data.map((item: NonResourcePricingTable, index: number) => ({ ...item, key: index + 1 }));
    setNonResourceData(newData);
  };

  const handledealEconomicsFinalData = (data: any[]) => {
    if (data.length > 0) {
      // setBelowTargetMarginReason(data[0]?.belowTargetMarginReason);
      // setDealPricingComment(data[0]?.dealPricingComment);
      setDealEconomicsFinalData(data ?? []);
    }
  };



  // ResourceAllocationPlan
  const monthColumns = monthlyHours.map(month => month.month);

  const calculateNetValue = (revenue: number, contingency: number, discount: number) => {
    const netRevenue = (revenue * (1 + (contingency / 100))) * (1 - (discount / 100))
    return netRevenue
  }

  // Whether a "MMM-YY" month column falls outside the given start/end date range (month granularity)
  const isMonthOutsideRange = (monthYear: string, startDate: any, endDate: any) => {
    const [month, year] = monthYear.split('-');
    const monthIndex = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"].indexOf(month);
    const fullYear = parseInt(`20${year}`, 10);
    const dateToCheck = dayjs(new Date(fullYear, monthIndex, 1));
    const startMonthYear = dayjs(new Date(startDate.year(), startDate.month(), 1));
    const endMonthYear = dayjs(new Date(endDate.year(), endDate.month(), 1));
    return dateToCheck.isBefore(startMonthYear) || dateToCheck.isAfter(endMonthYear);
  };

  const calculateWorkingDays = (startDate: any, endDate: any) => {
    let workingDays = 0;

    // Iterate through each day of the month
    for (let day = dayjs(startDate); day.isBefore(dayjs(endDate)) || day.isSame(endDate, 'day'); day = day.add(1, 'day')) {
      const weekDay = day.day(); // dayjs returns 0-6 (Sunday-Saturday)
      if (weekDay !== 0 && weekDay !== 6) {
        workingDays++;
      }
    }

    return workingDays;
  }

  const handleODELockAsSave = () => {
    setRequestODELock(true)
    setlockOde(true)
    // setSendHubspotLineItems(true)
    setUpdateHubspotDealAmount(true)
    setSendEmail(true)
    setNewVersionNameModalVisible(true)
    setReloadNavigation(true)
  }

  const handleResourceAllocationCallback = (data: ResourceAllocationPlanTable[]) => {
    setResourceFinalAllocationPlanData(data);
    const revenueDataMapper: any = []
    const serviceLineRevenue: any = []
    const serviceLineRevenueObject: any = {}
    const hasResources = ParticipantsAndRatesData.length > 0 && data.length === ParticipantsAndRatesData.length;
    const completeNonResource = nonResourceData.filter((nr: NonResourcePricingTable) => nr.selectRegion && nr.serviceLineCapability && nr.function && Number(nr.monthlyCost) > 0);
    const hasNonResource = completeNonResource.length > 0;
    if (!hasResources && !hasNonResource) {
      setRevenueData([])
      setMonthlySummaryData([])
      setMonthlySummaryDataAfterDiscount([])
      setServiceLineTotalRevenue([])
    } else {
      if (hasResources) {
      ParticipantsAndRatesData.forEach((element, index) => {
        const billableHours: any = { key: `${index + 1}-1`, role: "Billable Hours" }
        const monthlyRevenue: any = { key: `${index + 1}-2`, role: `Revenue ${currencySymbol}` }
        const costRevenue: any = { key: `${index + 1}-3`, role: `Cost ${currencySymbol}` }
        const clientMarginRevenue: any = { key: `${index + 1}-4`, role: `Client Margin ${currencySymbol}` }
        const targetRevenue: any = { key: `${index + 1}-5`, role: `Target Revenue ${currencySymbol}` }
        const targetMarginRevenue: any = { key: `${index + 1}-6`, role: `Target Margin ${currencySymbol}` }

        let totalBillableHours = 0
        let totalMonthlyRevenue = 0
        let totalConstRevenue = 0
        let totalClientMarginRevenue = 0
        let totalTargetRevenue = 0
        let totalTargetMarginRevenue = 0

        monthlyHours.map((month: any, i: any) => {
          const currentMonth = month.month.split('-')[0]
          const currentYear = month.month.split('-')[1]
          let currentMonthBillableCoefficient = 1

          // Map month abbreviations to month indices (0-based)
          const monthIndex = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"].indexOf(currentMonth);

          // Convert the two-digit year to a four-digit year
          const fullYear = parseInt(`20${currentYear}`, 10);

          // Create a new dayjs date for the 1st of the given month and year
          const dateToCheck = dayjs(new Date(fullYear, monthIndex, 1));
          let workingDays = calculateWorkingDays(dayjs(dateToCheck).startOf("month"), dayjs(dateToCheck).endOf("month"));
          // Calculate billable coefficient for partial months
          if (currentYear === data[index].startDate.format('YY').toUpperCase() &&
            currentYear === data[index].endDate.format('YY').toUpperCase() &&
            currentMonth === data[index].startDate.format('MMM').toUpperCase() &&
            currentMonth === data[index].endDate.format('MMM').toUpperCase()) {
            // Calculate billableDays in the month / total working days in the month
            currentMonthBillableCoefficient = calculateWorkingDays(data[index].startDate, data[index].endDate) / calculateWorkingDays(data[index].startDate.startOf("month"), data[index].startDate.endOf("month"));
            workingDays = calculateWorkingDays(data[index].startDate, data[index].endDate);
          }// Calculate billable coefficient for start month 
          else if (currentYear === data[index].startDate.format('YY').toUpperCase() && currentMonth === data[index].startDate.format('MMM').toUpperCase()) {
            // Calculate billableDays in start month / total working days in start month 
            currentMonthBillableCoefficient = (calculateWorkingDays(data[index].startDate, data[index].startDate.endOf("month"))) / calculateWorkingDays(data[index].startDate.startOf("month"), data[index].startDate.endOf("month"));
            workingDays = calculateWorkingDays(data[index].startDate, data[index].startDate.endOf("month"));
          } else if (currentYear === data[index].endDate.format('YY').toUpperCase() && currentMonth === data[index].endDate.format('MMM').toUpperCase()) {
            // Calculate billable coefficient for end month logic = 
            // billableDays in end month / total working days in end month
            currentMonthBillableCoefficient = (calculateWorkingDays(data[index].endDate.startOf("month"), data[index].endDate)) / calculateWorkingDays(data[index].endDate.startOf("month"), data[index].endDate.endOf("month"));
            workingDays = calculateWorkingDays(data[index].endDate.startOf("month"), data[index].endDate);
          }
          
          if(useOldWorkhours){
          billableHours[`month${i}`] = Math.round((month.hours.filter((hourData: any) => hourData.region == element.selectRegion && hourData.resourceType == element.resourceType)[0].hours * (data[index].months[`month${i}`] / 100) * currentMonthBillableCoefficient))
          } else {
          billableHours[`month${i}`] = Math.round((8 * workingDays * (data[index].months[`month${i}`] / 100)));
          }
          totalBillableHours += billableHours[`month${i}`]
          monthlyRevenue[`month${i}`] = Math.round((billableHours[`month${i}`] * element.proposedPriceHr))
          totalMonthlyRevenue += monthlyRevenue[`month${i}`]
          targetRevenue[`month${i}`] = Math.round((billableHours[`month${i}`] * element.targetPriceHr))
          totalTargetRevenue += targetRevenue[`month${i}`]
          costRevenue[`month${i}`] = Math.round((billableHours[`month${i}`] * element.loadedLaborCostHr))
          totalConstRevenue += costRevenue[`month${i}`]
          clientMarginRevenue[`month${i}`] = Math.round((monthlyRevenue[`month${i}`] - costRevenue[`month${i}`]))
          totalClientMarginRevenue += clientMarginRevenue[`month${i}`]
          targetMarginRevenue[`month${i}`] = Math.round((targetRevenue[`month${i}`] - costRevenue[`month${i}`]))
          totalTargetMarginRevenue += targetMarginRevenue[`month${i}`]
        })

        billableHours.total = Math.round(totalBillableHours)
        monthlyRevenue.total = Math.round(totalMonthlyRevenue)
        costRevenue.total = Math.round(totalConstRevenue)
        clientMarginRevenue.total = Math.round(totalClientMarginRevenue)
        targetRevenue.total = Math.round(totalTargetRevenue)
        targetMarginRevenue.total = Math.round(totalTargetMarginRevenue)

        if (!serviceLineRevenueObject[element.serviceLineCapability]) {//if the service line is not present in the object
          // const contingencyAmount = Number((totalMonthlyRevenue * (contingencyValue / 100)).toFixed(2))
          const contingencyAmount = 0
          const discountAmount = (totalMonthlyRevenue + contingencyAmount) * (discountValue / 100)
          serviceLineRevenueObject[element.serviceLineCapability] = { key: `${index + 1}`, service: element.serviceLineCapability, core: totalMonthlyRevenue, contingency: contingencyAmount, discount: discountAmount, net: calculateNetValue(totalMonthlyRevenue, 0, discountValue) }
        } else {//if the service line is present in the object
          // const contingencyAmount = Number((totalMonthlyRevenue * (contingencyValue / 100)).toFixed(2))
          const contingencyAmount = 0
          const discountAmount = (totalMonthlyRevenue + contingencyAmount) * (discountValue / 100)
          serviceLineRevenueObject[element.serviceLineCapability].contingency = ((serviceLineRevenueObject[element.serviceLineCapability].contingency + contingencyAmount))
          serviceLineRevenueObject[element.serviceLineCapability].discount = ((serviceLineRevenueObject[element.serviceLineCapability].discount + discountAmount))
          serviceLineRevenueObject[element.serviceLineCapability].core = ((serviceLineRevenueObject[element.serviceLineCapability].core + totalMonthlyRevenue))
          serviceLineRevenueObject[element.serviceLineCapability].net = ((serviceLineRevenueObject[element.serviceLineCapability].net + calculateNetValue(totalMonthlyRevenue, 0, discountValue)))
        }
        const objectData: RevenueData = {
          key: `month${index + 1}`,
          role: `${element.resourceType} - ${element.selectRegion} - ${element.serviceLineCapability} - ${element.selectLevel}`,
          total: Math.round(totalMonthlyRevenue),
          children: [billableHours, monthlyRevenue, targetRevenue, costRevenue, clientMarginRevenue, targetMarginRevenue]
        }
        Object.keys(monthlyRevenue).forEach((key: any) => {
          if (key.startsWith('month'))
            objectData[key] = monthlyRevenue[key]
        })
        revenueDataMapper.push(objectData)
      });
      }

      if (hasNonResource) {
        completeNonResource.forEach((element: NonResourcePricingTable) => {
          const index = revenueDataMapper.length;
          const monthlyRevenueVal = Number(element.targetPricePerMonth) || 0;
          const monthlyCostVal = Number(element.monthlyCost) || 0;
          const billableHours: any = { key: `${index + 1}-1`, role: "Billable Hours" }
          const monthlyRevenue: any = { key: `${index + 1}-2`, role: `Revenue ${currencySymbol}` }
          const costRevenue: any = { key: `${index + 1}-3`, role: `Cost ${currencySymbol}` }
          const clientMarginRevenue: any = { key: `${index + 1}-4`, role: `Client Margin ${currencySymbol}` }
          const targetRevenue: any = { key: `${index + 1}-5`, role: `Target Revenue ${currencySymbol}` }
          const targetMarginRevenue: any = { key: `${index + 1}-6`, role: `Target Margin ${currencySymbol}` }

          let totalMonthlyRevenue = 0
          let totalConstRevenue = 0
          let totalClientMarginRevenue = 0
          let totalTargetRevenue = 0
          let totalTargetMarginRevenue = 0

          monthlyHours.map((month: any, i: any) => {
            const isOutside = isMonthOutsideRange(month.month, element.startDate, element.endDate);
            // Non-resource has no billable hours; monthly cost/price apply in full to each in-range month
            billableHours[`month${i}`] = 0
            monthlyRevenue[`month${i}`] = isOutside ? 0 : Math.round(monthlyRevenueVal)
            totalMonthlyRevenue += monthlyRevenue[`month${i}`]
            targetRevenue[`month${i}`] = isOutside ? 0 : Math.round(monthlyRevenueVal)
            totalTargetRevenue += targetRevenue[`month${i}`]
            costRevenue[`month${i}`] = isOutside ? 0 : Math.round(monthlyCostVal)
            totalConstRevenue += costRevenue[`month${i}`]
            clientMarginRevenue[`month${i}`] = Math.round(monthlyRevenue[`month${i}`] - costRevenue[`month${i}`])
            totalClientMarginRevenue += clientMarginRevenue[`month${i}`]
            targetMarginRevenue[`month${i}`] = Math.round(targetRevenue[`month${i}`] - costRevenue[`month${i}`])
            totalTargetMarginRevenue += targetMarginRevenue[`month${i}`]
          })

          billableHours.total = 0
          monthlyRevenue.total = Math.round(totalMonthlyRevenue)
          costRevenue.total = Math.round(totalConstRevenue)
          clientMarginRevenue.total = Math.round(totalClientMarginRevenue)
          targetRevenue.total = Math.round(totalTargetRevenue)
          targetMarginRevenue.total = Math.round(totalTargetMarginRevenue)

          if (!serviceLineRevenueObject[element.serviceLineCapability]) {
            const contingencyAmount = 0
            const discountAmount = (totalMonthlyRevenue + contingencyAmount) * (discountValue / 100)
            serviceLineRevenueObject[element.serviceLineCapability] = { key: `${index + 1}`, service: element.serviceLineCapability, core: totalMonthlyRevenue, contingency: contingencyAmount, discount: discountAmount, net: calculateNetValue(totalMonthlyRevenue, 0, discountValue) }
          } else {
            const contingencyAmount = 0
            const discountAmount = (totalMonthlyRevenue + contingencyAmount) * (discountValue / 100)
            serviceLineRevenueObject[element.serviceLineCapability].contingency = ((serviceLineRevenueObject[element.serviceLineCapability].contingency + contingencyAmount))
            serviceLineRevenueObject[element.serviceLineCapability].discount = ((serviceLineRevenueObject[element.serviceLineCapability].discount + discountAmount))
            serviceLineRevenueObject[element.serviceLineCapability].core = ((serviceLineRevenueObject[element.serviceLineCapability].core + totalMonthlyRevenue))
            serviceLineRevenueObject[element.serviceLineCapability].net = ((serviceLineRevenueObject[element.serviceLineCapability].net + calculateNetValue(totalMonthlyRevenue, 0, discountValue)))
          }

          const objectData: RevenueData = {
            key: `month${index + 1}`,
            role: `Non-Resource - ${element.selectRegion} - ${element.serviceLineCapability} - ${element.function}`,
            total: Math.round(totalMonthlyRevenue),
            children: [billableHours, monthlyRevenue, targetRevenue, costRevenue, clientMarginRevenue, targetMarginRevenue]
          }
          Object.keys(monthlyRevenue).forEach((key: any) => {
            if (key.startsWith('month'))
              objectData[key] = monthlyRevenue[key]
          })
          revenueDataMapper.push(objectData)
        });
      }

      Object.keys(serviceLineRevenueObject).forEach((key) => {
        serviceLineRevenueObject[key].core = Math.round(serviceLineRevenueObject[key].core)
        serviceLineRevenueObject[key].contingency = Math.round(serviceLineRevenueObject[key].contingency)
        serviceLineRevenueObject[key].discount = Math.round(serviceLineRevenueObject[key].discount)
        serviceLineRevenueObject[key].net = Math.round(serviceLineRevenueObject[key].net)
        serviceLineRevenue.push(serviceLineRevenueObject[key])
      })
      setRevenueData(revenueDataMapper)
      const monthlSum: any = sumByCategoryAndMonth(revenueDataMapper)
      const monthlSumAfterDiscount: any = calculateSumAfterDiscountAndContingency(JSON.parse(JSON.stringify(monthlSum)))
      const roundedMonthlSumAfterDiscount:any = roundOffMonthlyValues(monthlSumAfterDiscount);

      // --- Begin Adjustment Logic for monthlSumAfterDiscount ---
      // Only declare totalRevenueObj once
      const totalRevenueObj = roundedMonthlSumAfterDiscount.find((item: any) => item.summary === "Total Revenue");
      if (totalRevenueObj && Array.isArray(totalRevenueObj.children)) {
        let serviceLines = totalRevenueObj.children;
        const sumServiceLines = serviceLines.reduce((acc: number, sl: any) => acc + (sl.total || 0), 0);
        const diff = (totalRevenueObj.total || 0) - sumServiceLines;
        // skip contingency and sort by total descending
        serviceLines = serviceLines.filter((item: any) => item.summary !== "Contingency").sort((a: any, b: any) => b.total - a.total);
        const n = serviceLines.length;
        const sign = Math.sign(diff);
        const absDiff = Math.abs(diff);
        for (let i = 0; i < absDiff; i++) {
          serviceLines[i % n].total += sign;
        }
      }
      // --- End Adjustment Logic for monthlSumAfterDiscount ---

      // Always update serviceLineRevenue with Contingency from adjusted monthlSumAfterDiscount
      const totalRevenue = roundedMonthlSumAfterDiscount.find((item: any) => item.summary === "Total Revenue");
      const contingencyTotalRevenue = totalRevenue?.children.find((child: any) => child.summary === "Contingency")?.total;
      serviceLineRevenue.push({ key: 'contingency', service: 'Contingency', core: contingencyTotalRevenue, contingency: 0, discount: 0, net: contingencyTotalRevenue });
      // update serviceLineRevenue net totalRevenueObj children net based summary
      totalRevenueObj?.children.forEach((child: any) => {
        const serviceLine = serviceLineRevenue.find((item: any) => item.service === child.summary);
        if (serviceLine) {
          serviceLine.net = child.total;
        }
      });
      setMonthlySummaryData(monthlSum)
      setMonthlySummaryDataAfterDiscount(roundedMonthlSumAfterDiscount)
      setServiceLineTotalRevenue(serviceLineRevenue)
    }

  };

  // Recompute all summaries when non-resource costs change (mirrors discount/contingency recompute)
  useEffect(() => {
    handleResourceAllocationCallback(ResourceFinalAllocationPlanData);
  }, [nonResourceData]);

  // Calculate Total Monthly Summary Before Discount and Contingency
  const sumByCategoryAndMonth = (data: any[]) => {
    const summary: Record<string, Record<string, any>> = {};
    const serviceLineTotalRevenueColumns: any = {}


    // Initialize the summary object
    const categories = ["Billable Hours", `Revenue ${currencySymbol}`, `Target Revenue ${currencySymbol}`, `Cost ${currencySymbol}`, `Client Margin ${currencySymbol}`, `Target Margin ${currencySymbol}`];
    categories.forEach((category) => {
      summary[category] = {}
      serviceLineTotalRevenueColumns[category] = {}
    });

    // Summing values for each category and month
    data.forEach((item) => {
      item.children.forEach((child: any) => {
        const category = child.role;
        if (!serviceLineTotalRevenueColumns[category][item.role.split(' - ')[2]])
          serviceLineTotalRevenueColumns[category][item.role.split(' - ')[2]] = {};
        Object.keys(child).forEach((key) => {
          if (key.startsWith("month")) {
            summary[category][key] = Number((Number((summary[category][key] || 0).toFixed(2)) + Number(child[key].toFixed(2))).toFixed(2));
            serviceLineTotalRevenueColumns[category][item.role.split(' - ')[2]][key] = Number((Number((serviceLineTotalRevenueColumns[category][item.role.split(' - ')[2]][key] || 0).toFixed(2)) + Number(child[key].toFixed(2))).toFixed(2));
            serviceLineTotalRevenueColumns[category][item.role.split(' - ')[2]]['total'] = Number((Number((serviceLineTotalRevenueColumns[category][item.role.split(' - ')[2]]['total'] || 0).toFixed(2)) + Number(child[key].toFixed(2))).toFixed(2));
          }
        });
      });
    });

    // Calculate client margin % for each month for each SL
    serviceLineTotalRevenueColumns["Client Margin %"] = {}
    Object.keys(serviceLineTotalRevenueColumns[`Revenue ${currencySymbol}`]).forEach((serviceLine) => {
      serviceLineTotalRevenueColumns["Client Margin %"][serviceLine] = {}
      Object.keys(serviceLineTotalRevenueColumns[`Revenue ${currencySymbol}`][serviceLine]).forEach((month) => {
        const revenue = serviceLineTotalRevenueColumns[`Revenue ${currencySymbol}`][serviceLine][month];
        const cost = serviceLineTotalRevenueColumns[`Cost ${currencySymbol}`][serviceLine][month];
        const marginPercentage = revenue ? 100 - (cost * 100) / revenue : 0;
        serviceLineTotalRevenueColumns["Client Margin %"][serviceLine][month] = `${marginPercentage.toFixed(1)}%`;
      })
    });

    // Calculate target margin % for each month for each SL
    serviceLineTotalRevenueColumns['Target Margin %'] = {};
    Object.keys(serviceLineTotalRevenueColumns[`Target Revenue ${currencySymbol}`]).forEach((serviceLine) => {
      serviceLineTotalRevenueColumns["Target Margin %"][serviceLine] = {}
      Object.keys(serviceLineTotalRevenueColumns[`Target Revenue ${currencySymbol}`][serviceLine]).forEach((month) => {
        const revenue = serviceLineTotalRevenueColumns[`Target Revenue ${currencySymbol}`][serviceLine][month];
        const cost = serviceLineTotalRevenueColumns[`Cost ${currencySymbol}`][serviceLine][month];
        const marginPercentage = revenue ? 100 - (cost * 100) / revenue : 0;
        serviceLineTotalRevenueColumns["Target Margin %"][serviceLine][month] = `${marginPercentage.toFixed(1)}%`;
      });
    });


    const results = [
      {
        key: '1',
        summary: 'Total Revenue',
        ...Object.fromEntries(
          Object.entries(summary[`Revenue ${currencySymbol}`]).map(([k, v]) => [k, v])
        ),
        total: Math.round(Object.values(summary[`Revenue ${currencySymbol}`]).reduce((acc, v) => acc + v, 0)),
        children: Object.entries(serviceLineTotalRevenueColumns[`Revenue ${currencySymbol}`]).map(([key, value]) => {
          return {
            summary: key,
            ...Object.fromEntries(
              Object.entries(serviceLineTotalRevenueColumns[`Revenue ${currencySymbol}`][key]).map(([k, v]) => [k, v])
            ),
          }
        })
      },
      {
        key: '2',
        summary: 'Total Target Revenue',
        ...Object.fromEntries(
          Object.entries(summary[`Target Revenue ${currencySymbol}`]).map(([k, v]) => [k, v])
        ),
        total: Math.round(Object.values(summary[`Target Revenue ${currencySymbol}`]).reduce((acc, v) => acc + v, 0)),
        children: Object.entries(serviceLineTotalRevenueColumns[`Target Revenue ${currencySymbol}`]).map(([key, value]) => {
          return {
            summary: key,
            ...Object.fromEntries(
              Object.entries(serviceLineTotalRevenueColumns[`Target Revenue ${currencySymbol}`][key]).map(([k, v]) => [k, v])
            )
          }
        })
      },

      {
        key: '3',
        summary: 'Total Billable Hours',
        ...summary['Billable Hours'],
        total: Math.round(Object.values(summary['Billable Hours']).reduce((acc, v) => acc + v, 0)),
        children: Object.entries(serviceLineTotalRevenueColumns['Billable Hours']).map(([key, value]) => {
          return {
            summary: key,
            ...Object.fromEntries(
              Object.entries(serviceLineTotalRevenueColumns['Billable Hours'][key]).map(([k, v]) => [k, v + ' hr'])
            )
          }
        })
      },
      {
        key: '4',
        summary: 'Total Cost',
        ...Object.fromEntries(
          Object.entries(summary[`Cost ${currencySymbol}`]).map(([k, v]) => [k, v])
        ),
        total: Math.round(Object.values(summary[`Cost ${currencySymbol}`]).reduce((acc, v) => acc + v, 0)),
        children: Object.entries(serviceLineTotalRevenueColumns[`Cost ${currencySymbol}`]).map(([key, value]) => {
          return {
            summary: key,
            ...Object.fromEntries(
              Object.entries(serviceLineTotalRevenueColumns[`Cost ${currencySymbol}`][key]).map(([k, v]) => [k, v])
            )
          }
        })
      },
      {
        key: '5',
        summary: `Total Client Margin ${currencySymbol}`,
        ...Object.fromEntries(
          Object.entries(summary[`Client Margin ${currencySymbol}`]).map(([k, v]) => [k, v])
        ),
        total: Math.round(Object.values(summary[`Client Margin ${currencySymbol}`]).reduce((acc, v) => acc + v, 0)),
        children: Object.entries(serviceLineTotalRevenueColumns[`Client Margin ${currencySymbol}`]).map(([key, value]) => {
          return {
            summary: key,
            ...Object.fromEntries(
              Object.entries(serviceLineTotalRevenueColumns[`Client Margin ${currencySymbol}`][key]).map(([k, v]) => [k, v])
            )
          }
        })
      },
      {
        key: '6',
        summary: `Total Target Margin ${currencySymbol}`,
        ...Object.fromEntries(
          Object.entries(summary[`Target Margin ${currencySymbol}`]).map(([k, v]) => [k, v])
        ),
        total: Math.round(Object.values(summary[`Target Margin ${currencySymbol}`]).reduce((acc, v) => acc + v, 0)),
        children: Object.entries(serviceLineTotalRevenueColumns[`Target Margin ${currencySymbol}`]).map(([key, value]) => {
          return {
            summary: key,
            ...Object.fromEntries(
              Object.entries(serviceLineTotalRevenueColumns[`Target Margin ${currencySymbol}`][key]).map(([k, v]) => [k, v])
            )
          }
        })
      }
    ];

    // Calculate client margin % for each month
    const clientMarginPercentage: any = {};
    Object.keys(summary[`Revenue ${currencySymbol}`]).forEach((month) => {
      const revenue = summary[`Revenue ${currencySymbol}`][month];
      const cost = summary[`Cost ${currencySymbol}`][month];
      const marginPercentage = revenue ? 100 - (cost * 100) / revenue : 0;
      clientMarginPercentage[month] = `${marginPercentage.toFixed(1)}%`;
    });

    // Add client margin % to the results
    results.push({
      key: '7',
      summary: 'Client Margin %',
      ...clientMarginPercentage,
      total: `${Object.values(summary[`Revenue ${currencySymbol}`]).reduce((acc, v) => acc + v, 0) === 0 ? 0 : (
        100 -
        (Object.values(summary[`Cost ${currencySymbol}`]).reduce((acc, v) => acc + v, 0) * 100) /
        Object.values(summary[`Revenue ${currencySymbol}`]).reduce((acc, v) => acc + v, 0)
      ).toFixed(1)}%`,
      children: Object.entries(serviceLineTotalRevenueColumns['Client Margin %']).map(([key, value]) => {
        return {
          summary: key,
          ...Object.fromEntries(
            Object.entries(serviceLineTotalRevenueColumns['Client Margin %'][key]).map(([k, v]) => [k, v])
          )
        }
      })
    });

    // Calculate target margin % for each month
    const targetMarginPercentage: any = {};
    Object.keys(summary[`Target Revenue ${currencySymbol}`]).forEach((month) => {
      const revenue = summary[`Target Revenue ${currencySymbol}`][month];
      const cost = summary[`Cost ${currencySymbol}`][month];
      const marginPercentage = revenue ? 100 - (cost * 100) / revenue : 0;
      targetMarginPercentage[month] = `${marginPercentage.toFixed(1)}%`;
    });

    // Add target margin % to the results
    results.push({
      key: '8',
      summary: 'Target Margin %',
      ...targetMarginPercentage,
      total: `${Object.values(summary[`Target Revenue ${currencySymbol}`]).reduce((acc, v) => acc + v, 0) === 0 ? 0 : (
        100 -
        (Object.values(summary[`Cost ${currencySymbol}`]).reduce((acc, v) => acc + v, 0) * 100) /
        Object.values(summary[`Target Revenue ${currencySymbol}`]).reduce((acc, v) => acc + v, 0)
      ).toFixed(1)}%`,
      children: Object.entries(serviceLineTotalRevenueColumns['Target Margin %']).map(([key, value]) => {
        return {
          summary: key,
          ...Object.fromEntries(
            Object.entries(serviceLineTotalRevenueColumns['Target Margin %'][key]).map(([k, v]) => [k, v])
          )
        }
      })
    });

    return results;
  };

  // Calculate Total Monthly Summary After Discount and Contingency
  const calculateSumAfterDiscountAndContingency = (data: any[]) => {
    let summaryAfterDiscountAndContingency = data.map((item) => {
      // Loop through each month and total keys
      const updatedItem = { ...item };
      // Gather all unique month keys dynamically
      const monthKeys = new Set<string>();
      Object.keys(item.children).forEach(key => {
        if (key.startsWith("month")) {
          monthKeys.add(key);
        }
      });
      // Create the new "Contingency" entry with all month values set to 0
      const newEntry: any = { summary: "Contingency", total: 0 };
      monthKeys.forEach(key => {
        newEntry[key] = 0;
      });
      item.children.push(newEntry);

      // Update only numeric values (ignore percentage strings)
      if (!['Total Target Revenue', `Total Target Margin ${currencySymbol}`, 'Target Margin %'].includes(item['summary'])) {
        for (const key in item) {
          if (key.startsWith("month") || key === "total") {
            if (typeof item[key] === "number") {
              // Add contingency and subtract discount
              if (item['summary'] !== 'Total Cost') {
                if (item['summary'] === 'Total Billable Hours') {
                  updatedItem[key] = Math.round(item[key] * (1 + (contingencyValue / 100))) + ' hr';
                } else {
                  updatedItem[key] = Math.round(Math.round(item[key] * (1 + (contingencyValue / 100))) * (1 - (discountValue / 100)));
                }
              }
              else
                updatedItem[key] = Math.round(item[key] * (1 + (contingencyValue / 100)));
            }

            item.children.forEach((child: any) => {
              if (child.summary !== "Contingency") {
                if (typeof child[key] === "number") {
                  // Add contingency and subtract discount
                  if (item['summary'] !== 'Total Cost' && item['summary'] !== 'Total Billable Hours')
                    child[key] = Math.round(child[key] * (1 - (discountValue / 100)));
                }
              } else {
                if (item['summary'] !== 'Total Cost') {
                  if (item['summary'] === 'Total Billable Hours') {
                    child[key] = Math.round(item[key] * (contingencyValue / 100)) + ' hr';
                  } else {
                    child[key] = Math.round(item[key] * ((100 - discountValue) / 100) * (contingencyValue / 100));
                  }
                }
                else
                  child[key] = Math.round(item[key] * (contingencyValue / 100));
              }
            });

          }
        }
      }
      return updatedItem;
    });

    // Function to calculate the client margin dollar amount
    const calculateClientMarginDollar = (revenue: number, cost: number): number => {
      return revenue - cost;
    }

    // Function to calculate the client margin percentage
    const calculateClientMargin = (revenue: number, cost: number): string => {
      return revenue !== 0 ? revenue - cost !== 0 ? ((revenue - cost) / revenue * 100).toFixed(1) + '%' : '0.0%' : '0.0%';
    };

    // Find the total revenue, total cost, and client margin objects from the data array
    const totalRevenue = summaryAfterDiscountAndContingency.find(item => item.summary === "Total Revenue");
    const totalCost = summaryAfterDiscountAndContingency.find(item => item.summary === "Total Cost");
    const clientMarginDollar = summaryAfterDiscountAndContingency.find(item => item.summary ===  `Total Client Margin ${currencySymbol}`);
    const clientMargin = summaryAfterDiscountAndContingency.find(item => item.summary === "Client Margin %");

    if (totalRevenue && totalCost && clientMarginDollar) {
      // Function to calculate margins for each key in the objects
      const calculateMarginsDollar = (revenueObj: any, costObj: any, marginObj: any) => {
        for (const key in revenueObj) {
          // Skip the keys that are not relevant for margin calculation
          if (key !== 'summary' && key !== 'key' && key !== 'children') {
            marginObj[key] = calculateClientMarginDollar(revenueObj[key], costObj[key]);
          }
        }
      };

      // Calculate margins for the total revenue and total cost
      calculateMarginsDollar(totalRevenue, totalCost, clientMarginDollar);

      // Calculate margins for each child, ignoring "Contingency"
      clientMarginDollar.children?.forEach((child: any) => {
        if (child.summary !== "Contingency") {
          const revenueChild = totalRevenue.children?.find((c: any) => c.summary === child.summary);
          const costChild = totalCost.children?.find((c: any) => c.summary === child.summary);
          if (revenueChild && costChild) {
            calculateMarginsDollar(revenueChild, costChild, child);
          }
        }
      });
    }

    if (totalRevenue && totalCost && clientMargin) {
      // Function to calculate margins for each key in the objects
      const calculateMargins = (revenueObj: any, costObj: any, marginObj: any) => {
        for (const key in revenueObj) {
          // Skip the keys that are not relevant for margin calculation
          if (key !== 'summary' && key !== 'key' && key !== 'children') {
            marginObj[key] = calculateClientMargin(revenueObj[key], costObj[key]);
          }
        }
      };

      // Calculate margins for the total revenue and total cost
      calculateMargins(totalRevenue, totalCost, clientMargin);

      // Calculate margins for each child, ignoring "Contingency"
      clientMargin.children?.forEach((child: any) => {
        if (child.summary !== "Contingency") {
          const revenueChild = totalRevenue.children?.find((c: any) => c.summary === child.summary);
          const costChild = totalCost.children?.find((c: any) => c.summary === child.summary);
          if (revenueChild && costChild) {
            calculateMargins(revenueChild, costChild, child);
          }
        }
      });
    }

    return summaryAfterDiscountAndContingency;
  }

  const savePricingVersionDetails = async (resourceRequestConfirmation?: ResourceRequestConfirmation) => {
    setSavePricingLoader(true);
    if (discountValue != 0 || ParticipantsAndRatesData.length == 0 || ResourceFinalAllocationPlanData.length == 0) {
      // if (ParticipantsAndRatesData.length == 0 || ResourceFinalAllocationPlanData.length == 0) {
      //   setSavePricingLoader(false);
      //   window.scrollTo({
      //     top: 0, // Scroll to the top
      //     behavior: 'smooth' // Smooth scrolling
      //   });
      //   return setError('Please add participants and rates');
      // }
      if (discountValue !== 0 && !discountRationale) {
        setSavePricingLoader(false);
        window.scrollTo({
          top: 0, // Scroll to the top
          behavior: 'smooth' // Smooth scrolling
        });
        return setError('Please provide a discount rationale');
      }
    }
    const saveResponse = await savePricingDealVersion(dealId, versionName, discountValue, discountRationale, contingencyValue, hubspotDropdownDetails, ParticipantsAndRatesData, ResourceFinalAllocationPlanData, dealEconomicsFinalData, sendEmail, lockOde, additionalResourcingInfo, HubspotDealData['Currency'], updateHubspotDealAmount, revenueData, monthlySummaryData, monthlySummaryDataAfterDiscount, currencySymbolsMap[HubspotDealData['Currency']], nonResourceData, resourceRequestConfirmation)
    if (saveResponse.confirmation_required && saveResponse.preview) {
      setSavePricingLoader(false)
      setResourceRequestPreview(saveResponse.preview)
      setResourceMappingModalOpen(true)
      return
    }
    if (saveResponse.error_status === 401) {
      setSavePricingLoader(false);
      setTokenExpired(true);
    } else {
      if (saveResponse.error) {
        setSavePricingLoader(false);
        console.error('Error Response Data:', saveResponse.error);
        console.error('Error Response Status:', saveResponse.error_status);
        setError(normalizeErrorMessage(saveResponse.error));
      } else {
        if (sendHubspotLineItems) {
          let updateLineItems = await updateHubspotLineItems(dealId, updatedPricingItems, saveResponse['version_id'], saveResponse['version_name']);
          if (updateLineItems.error_status === 401) {
            setSavePricingLoader(false);
            setTokenExpired(true);
          } else {
            if (updateLineItems.error) {
              setSavePricingLoader(false);
              console.error('Error Response Data:', updateLineItems.error);
              console.error('Error Response Status:', updateLineItems.error_status);
              setError(normalizeErrorMessage(updateLineItems.error));
            } else {
              setSavePricingLoader(false);
              setIsSuccessModalVisible(true);
            }
          }
        } else {
          setSavePricingLoader(false);
          setIsSuccessModalVisible(true);
        }
      }
    }
  }

  const retryOdeLock = async () => {
    setRetryingOdeLock(true);
    const response = await lockPricingDeal(dealId, versionName);
    setRetryingOdeLock(false);
    if (response?.error) {
      setError(response.error);
      return;
    }
    setError(null);
    setIsDealLocked(true);
    message.success('Pricing version locked as ODE.');
    window.location.reload();
  };
  const handleAmountChange = (name: string, amount: number) => {
    setUpdatedPricingItems((prevState: any) => {
      const serviceLineExists = prevState.findIndex((item: any) => item.name === name);
      if (serviceLineExists !== -1) {
        const updatedServiceLineItems = [...prevState];
        updatedServiceLineItems[serviceLineExists].amount = amount;
        return updatedServiceLineItems;
      } else {
        return [...prevState, { name, amount }];
      }
    });
  }
  const checkValidations = () => {
    // if(ParticipantsAndRatesData.length > 0 || ResourceFinalAllocationPlanData.length > 0 || dealEconomicsFinalData.length > 0){
    const validateInputsObject: any = { "Deal Id": dealId, "Version Name": versionName, "Resource Data": ParticipantsAndRatesData, "Resource Allocation Data": ResourceFinalAllocationPlanData, "Deal Economics Data": dealEconomicsFinalData }
    if (discountValue != 0) {
      validateInputsObject["Discount Rationale"] = discountRationale
    }
    if (dealEconomicsFinalData.length > 0 && dealEconomicsFinalData[0]['varianceToTargetMargin']?.replace('%', '') < 0) {
      validateInputsObject["Below Target Margin Reason"] = dealEconomicsFinalData[0]['belowTargetMarginReason']
    }
    const validationErrors = validateInputs(validateInputsObject);
    if (validationErrors.length > 0) {
      setError(validationErrors.map(error => `${error.key}:${error.error}`).join(","))
      window.scrollTo({
        top: 0, // Scroll to the top
        behavior: "smooth", // Smooth scrolling
      });
    } else {
      setError("")
      setNewVersionNameModalVisible(true);
    }
    // }else{
    //   setError("Please add participants and rates data")
    //   window.scrollTo({
    //     top: 0, // Scroll to the top
    //     behavior: "smooth", // Smooth scrolling
    //   });
    // }
  }

    const handleDealRefresh = async () => {
      setRefreshingDeal(true)
      await refreshDeals(dealId).then((resp) => {
        if(resp.error ?? '') {
          message.error(resp.error)
          return
        }
        message.success("Successfully Refreshed the Deal");
        window.location.reload();
      })
      .catch((error) => {
        setRefreshingDeal(false);
        message.error("Failed to Refresh the Deal");
      });
    }


  // Fetch HubSpot deal details when component mounts
  useEffect(() => {
    if (dealId !== null && dealId !== undefined && dealId > 0) {
      const fetchDealDetails = async () => {
        const featureListPromise: any = getLoggedInUserDetails(dealId);
        const pricingContributorsPromise: any = getPricingContributors(dealId);
        const pricingVersionPromise: any = getPricingVersion(dealId)
        const dealVersionDetailsPromise: any = getDealVersionDetails(dealId, versionName);
        const discountTargetMarginDDPromise = getDiscountTargetMarginDD(dealId);

        const featureList: any = await featureListPromise;
        const pricingContributors: any = await pricingContributorsPromise;
        const pricingVersion: any = await pricingVersionPromise;
        const dealVersionDetails: any = await dealVersionDetailsPromise;
        const discountTargetMarginDD = await discountTargetMarginDDPromise;
        let base_price_version_id = dealVersionDetails.base_price_version_id;
        setPipelineName(dealVersionDetails.pipeline_name ?? '');
        setUseOldWorkhours(dealVersionDetails.use_old_workhours ?? false);

        const stageListLessThan4 = ["0- New", "Needs Expressed", "0- New", "Qualified Opportunity", "Connected to Meet", "Discovery", "1- Connected to Meet", "2- Needs Expressed", "3- Qualified Opportunity"]
        if (pricingVersion.length >= 1 && stageListLessThan4.includes(dealVersionDetails.deal_stage_name) && !dealVersionDetails.is_deal_locked) {
          const latestVersion = pricingVersion.sort((a: any, b: any) => new Date(b.created_on).getTime() - new Date(a.created_on).getTime())[0];
          base_price_version_id = latestVersion.id;
        }
        setVersionId(base_price_version_id);
        const pricingCalculatorDetailsDataPromise: any = getPricingCalculatorDetails(dealId, base_price_version_id);
        const workingHoursPromise = getWorkHours(dealId, base_price_version_id);
        const pricingCalculatorDetailsResponse: any = await pricingCalculatorDetailsDataPromise;
        const pricingCalculatorDetailsData: any[] = Array.isArray(pricingCalculatorDetailsResponse)
          ? pricingCalculatorDetailsResponse
          : [];
        const nonResourcePricingDetailsPromise: any = getNonResourcePricingDetails(dealId, base_price_version_id);
        const workingHours = await workingHoursPromise;
        const nonResourcePricingDetailsData: any = await nonResourcePricingDetailsPromise;


        if (!featureList?.error && !pricingContributors?.error && !pricingVersion?.error && !dealVersionDetails?.error && !pricingCalculatorDetailsResponse?.error && !workingHours?.error && !discountTargetMarginDD?.error) {
          const fatalError = checkStartDateAndDuration(dealVersionDetails.project_start_date, dealVersionDetails.duration_in_months)
          if (fatalError !== '') {
            setFatalError(fatalError)
            setIsRedirectToHome(true)
          }
          const totalNoOfMonths = dealVersionDetails?.resource_allocation_plan.length > 0 ? Object.keys(dealVersionDetails.resource_allocation_plan[0].monthly_wise_allocation).length - 1 : 0;
          const monthlyHours = getMonthlyWorkingHours(dealVersionDetails.is_deal_locked ? dealVersionDetails.pricing_version_project_start_date : dealVersionDetails.project_start_date, dealVersionDetails.is_deal_locked ? dealVersionDetails.pricing_version_duration_in_months : dealVersionDetails.duration_in_months, workingHours,totalNoOfMonths);

          setExistingMonthlyAllocation(totalNoOfMonths);
          setEnabledFeatureList(featureList.data.features);
          setIsDealVersionDetailsLoaded(true);
          setMonthlyHours(monthlyHours);
          setIsDealLocked(dealVersionDetails['is_deal_locked'] ? dealVersionDetails['is_deal_locked'] : false)

          if (!dealVersionDetails['duration_in_months']) {
            setErrorArray([...errorArray, { 'Duration': 'Duration is not valid' }])
          }
          // Extract distinct service_line
          const distinctServiceLines: string[] = Array.from(new Set(pricingCalculatorDetailsData.map((obj: any) => obj.service_line)));
          const distinctRegions: string[] = Array.from(new Set(pricingCalculatorDetailsData.map((obj: any) => obj.region)));
          const distinctCareerLevels: string[] = Array.from(new Set(pricingCalculatorDetailsData.map((obj: any) => obj.career_level)));
          const distinctFunctions: string[] = Array.from(new Set(pricingCalculatorDetailsData.map((obj: any) => obj.function)));
          const distinctResourceTypes: string[] = Array.from(new Set(pricingCalculatorDetailsData.map((obj: any) => obj.resource_type)));

          const dealDetails: HubSpotData = {
            'Deal Name': dealVersionDetails.deal_name,
            'pdc': dealVersionDetails?.pricing_contributors.map((item: any) => item.email) || ['oveek.chatterjee@blend360.com'],
            'Client Name': dealVersionDetails.company_name,
            'HubSpot ID': dealVersionDetails.deal_id,
            'Deal Owner': dealVersionDetails.deal_owner_name,
            'Deal Stage': dealVersionDetails.deal_stage_name,
            'Engagement Type': dealVersionDetails.engagement_type,
            'Expected Start Date': new Date(dealVersionDetails.project_start_date).toLocaleDateString() , // Format as needed
            'Close Date': dealVersionDetails.project_close_date ? new Date(dealVersionDetails.project_close_date).toLocaleDateString() : dealVersionDetails.project_close_date, // Format as needed
            'Duration': `${dealVersionDetails.duration_in_months} months`,
            'Deal Collaborators': dealVersionDetails?.deal_collaborators.map((item: any) => item.email) || ['ramakrishna.pinni@blend360.com'],
            'Work Ahead': dealVersionDetails.work_ahead,
            "Currency": dealVersionDetails.hs_deal_currency,
            "2026 Book": dealVersionDetails.book_2026_name,
            'Offering': dealVersionDetails.offering ?? '',
            'Deal Description': dealVersionDetails.description ?? '',
            'Tech Involved': dealVersionDetails.tech_involved ?? '',
            'bpv': pricingVersion.at(-1).name,
            'Deal Amount in HubSpot': dealVersionDetails.deal_amount,
            'Delivery Lead Name': dealVersionDetails.delivery_lead_name,
            'Solution Lead Name': dealVersionDetails.solution_lead_name,
            'Deal Line Items': dealVersionDetails.hubspot_line_items,
            'Hubspot Link': dealVersionDetails.hubspot_link,
            'Resource Request Sent On': dealVersionDetails.resource_request_sent_on,
            'Locked Version Name': dealVersionDetails.locked_version_name,
            'HS Last Updated Version Name': dealVersionDetails.hs_last_updated_version_name,
            'Deal Locked On': dealVersionDetails.deal_locked_on,
            'Version Id': dealVersionDetails.version_id,
            'Locked Version Id': dealVersionDetails.locked_version_id,
            'Pricing Version Project Start Date': new Date(dealVersionDetails.pricing_version_project_start_date ?? dealVersionDetails.project_start_date).toLocaleDateString(),
            'Pricing Version Duration': dealVersionDetails.pricing_version_duration_in_months ?? dealVersionDetails.duration_in_months,
            'Pricing Version Engagement Type': dealVersionDetails.pricing_version_engagement_type ?? '',
            'Unlock Request Reason': dealVersionDetails.unlock_request_reason ?? '',
            'Unlock Comments': dealVersionDetails.unlock_comments ?? '',
          };
          
          updateCurrency(dealVersionDetails.hs_deal_currency);
          setAdditionalResourcingInfo(dealVersionDetails.additional_resourcing_info ?? '')
          setDealLastRefereshedOn(dayjs(dealVersionDetails.last_refreshed_on).tz('America/New_York').format('ddd, MMM D, YYYY, h:mm:ss A z'))
          setStartDate(dayjs(dealVersionDetails.project_start_date));
          setEndDate(getProjectEndDate(dealVersionDetails.project_start_date, dealVersionDetails.duration_in_months));
          setDuration(dealVersionDetails.duration_in_months);

          // Non-Resource: catalog for dropdowns (defensive — missing endpoint should not block the page)
          setNonResourcePricingDetails(Array.isArray(nonResourcePricingDetailsData) ? nonResourcePricingDetailsData : []);
          const nonResourceDefaultStart = dayjs(dealVersionDetails.project_start_date);
          const nonResourceDefaultEnd = getProjectEndDate(dealVersionDetails.project_start_date, dealVersionDetails.duration_in_months);
          const cleanDate = (d: string) => d.replace(/Z$/, '').replace(/[-+]\d{2}:\d{2}$/, "");
          setNonResourceInitialData((dealVersionDetails.non_resource_data ?? []).map((item: any, index: number) => {
            const monthlyCost = item.monthly_cost ?? 0;
            const targetClientMargin = item.target_client_margin ?? 0;
            const denom = 100 - targetClientMargin;
            return {
              'key': item.key ?? index + 1,
              'oldKey': item.key ?? index + 1,
              'selectRegion': item.region,
              'serviceLineCapability': item.service_line,
              'function': item.function,
              'monthlyCost': monthlyCost,
              'targetClientMargin': targetClientMargin,
              'targetPricePerMonth': denom > 0 ? Number(((monthlyCost * 100) / denom).toFixed(2)) : 0,
              'startDate': item.start_date ? dayjs(cleanDate(item.start_date)) : nonResourceDefaultStart,
              'endDate': item.end_date ? dayjs(cleanDate(item.end_date)) : nonResourceDefaultEnd,
            }
          }));
          dealVersionDetails.participants_rate_data = cleanResourceRequestList(dealVersionDetails.participants_rate_data, {
            resourceTypes: distinctResourceTypes,
            selectRegions: distinctRegions,
            serviceLineCapabilities: distinctServiceLines,
            functions: distinctFunctions,
            selectLevels: distinctCareerLevels
          });
          setParticipantsAndRatesInitialData(dealVersionDetails.participants_rate_data.map((item: any) => {
            const lookUpValues = pricingCalculatorDetailsData.filter((data: any) => data.resource_type === item.resource_type && data.region === item.region && data.service_line === item.service_line && data.career_level === item.career_level && data.function === item.function)[0];
            const loadedLaborCostHr = lookUpValues?.cost_per_hour ?? item.cost_per_hour;
            const targetClientMargin = lookUpValues?.target_client_margin ? Number((lookUpValues?.target_client_margin * 100).toFixed(2)) : item.target_client_margin;
            const minFTE = lookUpValues?.min_fte_allocation ?? 0;
            return {
              'key': item.key,
              'oldKey': item.key,
              'resourceType': item.resource_type,
              'selectRegion': item.region,
              'serviceLineCapability': item.service_line,
              'function': item.function,
              'selectLevel': item.career_level,
              'loadedLaborCostHr': loadedLaborCostHr,
              'targetClientMargin': targetClientMargin,
              'proposedPriceHr': item.proposed_price_per_hour,
              'targetPriceHr': Number(((loadedLaborCostHr * 100) / (100 - targetClientMargin)).toFixed(2)),
              'clientMarginProposed': Number((100 - ((100 * loadedLaborCostHr) / (item.proposed_price_per_hour))).toFixed(2)),
              'varianceTargetMargin': (Number((100 - ((100 * loadedLaborCostHr) / (item.proposed_price_per_hour))).toFixed(2))) - targetClientMargin,
              'minFTE': minFTE,
              'resourceRequirementId': item.resource_requirement_id ?? undefined
            }
          }))

          if ((dealVersionDetails.project_start_date !== dealVersionDetails.pricing_version_project_start_date || dealVersionDetails.duration_in_months !== dealVersionDetails.pricing_version_duration_in_months) && !dealVersionDetails.is_deal_locked) {
            const diff = calculateDaysBetweenDates(dealVersionDetails.pricing_version_project_start_date, dealVersionDetails.project_start_date);
            setResourceFinalAllocationPlanData(dealVersionDetails.resource_allocation_plan.map((item: any, index: number) => ({
              'key': item.key,
              'oldKey': item.key,
              'role': `${dealVersionDetails.participants_rate_data[index].resource_type} - ${dealVersionDetails.participants_rate_data[index].region} - ${dealVersionDetails.participants_rate_data[index].service_line} - ${dealVersionDetails.participants_rate_data[index].career_level}`,
              'allocation': item.allocation,
              'startDate': dayjs(calculateStartDate(dealVersionDetails.project_start_date, dealVersionDetails.duration_in_months, addOrSubtractDays(item.start_date.replace(/Z$/, '').replace(/[-+]\d{2}:\d{2}$/, ""), diff)).replace(/Z$/, '').replace(/[-+]\d{2}:\d{2}$/, "")),
              'endDate': dayjs(calculateEndDate(dealVersionDetails.project_start_date, dealVersionDetails.duration_in_months, addOrSubtractDaysForEndDate(item.end_date.replace(/Z$/, '').replace(/[-+]\d{2}:\d{2}$/, ""), diff, dealVersionDetails.project_start_date, dealVersionDetails.pricing_version_project_start_date,item.start_date)).replace(/Z$/, '').replace(/[-+]\d{2}:\d{2}$/, "")),
              'oldStartDate': dayjs(item.start_date.replace(/Z$/, '').replace(/[-+]\d{2}:\d{2}$/, "")),
              'oldEndDate': dayjs(item.end_date.replace(/Z$/, '').replace(/[-+]\d{2}:\d{2}$/, "")),
              'duration': item.duration,
              'months': item.monthly_wise_allocation,
              'name': item.name,
              'comment': item.comment,
              'startDateWarning': true,
              'endDateWarning': true,
              'minFTE': dealVersionDetails.participants_rate_data[index].minFTE
            }))
            );
          } else if ((dealVersionDetails.project_start_date !== dealVersionDetails.pricing_version_project_start_date || dealVersionDetails.duration_in_months !== dealVersionDetails.pricing_version_duration_in_months) && dealVersionDetails.is_deal_locked) {
            setResourceFinalAllocationPlanData(dealVersionDetails.resource_allocation_plan.map((item: any, index: number) => ({
              'key': item.key,
              'oldKey': item.key,
              'role': `${dealVersionDetails.participants_rate_data[index].resource_type} - ${dealVersionDetails.participants_rate_data[index].region} - ${dealVersionDetails.participants_rate_data[index].service_line} - ${dealVersionDetails.participants_rate_data[index].career_level}`,
              'allocation': item.allocation,
              'startDate': dayjs(item.start_date.replace(/Z$/, '').replace(/[-+]\d{2}:\d{2}$/, "")),
              'endDate': dayjs(item.end_date.replace(/Z$/, '').replace(/[-+]\d{2}:\d{2}$/, "")),
              'duration': item.duration,
              'months': item.monthly_wise_allocation,
              'name': item.name,
              'comment': item.comment,
              'startDateWarning': true,
              'endDateWarning': true,
              'minFTE': dealVersionDetails.participants_rate_data[index].minFTE
            }))
            );
          } else if ((dealVersionDetails.project_start_date === dealVersionDetails.pricing_version_project_start_date && dealVersionDetails.duration_in_months === dealVersionDetails.pricing_version_duration_in_months)) {
            setResourceFinalAllocationPlanData(dealVersionDetails.resource_allocation_plan.map((item: any, index: number) => ({
              'key': item.key,
              'oldKey': item.key,
              'role': `${dealVersionDetails.participants_rate_data[index].resource_type} - ${dealVersionDetails.participants_rate_data[index].region} - ${dealVersionDetails.participants_rate_data[index].service_line} - ${dealVersionDetails.participants_rate_data[index].career_level}`,
              'allocation': item.allocation,
              'startDate': dayjs(item.start_date.replace(/Z$/, '').replace(/[-+]\d{2}:\d{2}$/, "")),
              'endDate': dayjs(item.end_date.replace(/Z$/, '').replace(/[-+]\d{2}:\d{2}$/, "")),
              'duration': item.duration,
              'months': item.monthly_wise_allocation,
              'name': item.name,
              'comment': item.comment,
              'startDateWarning': false,
              'endDateWarning': false,
              'minFTE': dealVersionDetails.participants_rate_data[index].minFTE
            }))
            );
          }

          setDiscountValue(dealVersionDetails.project_discount);
          setcontingencyValue(dealVersionDetails.fixed_fee_contingency);
          setDiscountRationale(dealVersionDetails.discount_rationale);
          setDealPricingComment(dealVersionDetails.deal_economics_summaries.deal_pricing_comment);
          setBelowTargetMarginReason(dealVersionDetails.deal_economics_summaries.below_target_margin_reason);

          setPricingVersion(pricingVersion);
          setPricingContributors(pricingContributors);
          setHubspotDealData(dealDetails);
          setPricingCollaborators(dealVersionDetails.deal_collaborators);
          setPricingCalculatorDetails(pricingCalculatorDetailsData);
          setWorkHours(workingHours);
          setTargetMarginDD(discountTargetMarginDD.below_target_margin_reasons);
          setDiscountRationaleDD(discountTargetMarginDD.discount_rationale);

          const hubspotFieldsChangedArray = [];
          if (dealVersionDetails.project_start_date?.substring(0, 10) !== dealVersionDetails.pricing_version_project_start_date?.substring(0, 10))
            hubspotFieldsChangedArray.push({ "key": "Expected Start Date", "Hubspot Data": dealVersionDetails.project_start_date ? new Date(dealVersionDetails.project_start_date).toLocaleDateString() : dealVersionDetails.project_start_date, "Pricing Version Data": dealVersionDetails.pricing_version_project_start_date ? new Date(dealVersionDetails.pricing_version_project_start_date).toLocaleDateString() : dealVersionDetails.pricing_version_project_start_date });
          if (dealVersionDetails.duration_in_months !== dealVersionDetails.pricing_version_duration_in_months)
            hubspotFieldsChangedArray.push({ "key": "Duration", "Hubspot Data": dealVersionDetails.duration_in_months, "Pricing Version Data": dealVersionDetails.pricing_version_duration_in_months });
          if (dealVersionDetails.engagement_type !== dealVersionDetails.pricing_version_engagement_type) {
            hubspotFieldsChangedArray.push({ "key": "Engagement Type", "Hubspot Data": dealVersionDetails.engagement_type, "Pricing Version Data": dealVersionDetails.pricing_version_engagement_type });
            if(!dealVersionDetails.is_deal_locked){
              dealVersionDetails.engagement_type === 'Fixed Fee' ? setcontingencyValue(20) : setcontingencyValue(0);
            }
          }
          if(dealVersionDetails.hs_deal_currency !== dealVersionDetails.pricing_version_currency) {
            hubspotFieldsChangedArray.push({ "key": "Currency", "Hubspot Data": dealVersionDetails.hs_deal_currency, "Pricing Version Data": dealVersionDetails.pricing_version_currency });
          }

          setHubspotFieldsChangedArray(hubspotFieldsChangedArray);
          if (hubspotFieldsChangedArray.length > 0)
            setIsHubspotFieldsChanged(true);

          setDistinctServiceLines([...distinctServiceLines, "Contingency"]);
        } else {
          if (featureList?.error_status === 401 || pricingContributors?.error_status === 401 || pricingVersion?.error_status === 401 || dealVersionDetails?.error_status === 401 || pricingCalculatorDetailsResponse?.error_status === 401 || workingHours?.error_status === 401 || discountTargetMarginDD?.error_status === 401) {
            setTokenExpired(true);
          }
          else if (featureList?.error_status === 403 || pricingContributors?.error_status === 403 || pricingVersion?.error_status === 403 || dealVersionDetails?.error_status === 403 || pricingCalculatorDetailsResponse?.error_status === 403 || workingHours?.error_status === 403 || discountTargetMarginDD?.error_status === 403) {
            setNoAccess(true);
          }
          setError([featureList, pricingContributors, pricingVersion, dealVersionDetails, pricingCalculatorDetailsResponse, workingHours, discountTargetMarginDD]
            .map((response: any) => response?.error)
            .filter(Boolean)
            .join(' '));

        }
        setLoading(false);
      };
      fetchDealDetails();
    } else {
      setError('Deal ID is missing');
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const fetchPricingDealVersionsData = async () => {
      const pricingDealVersions = await getPricingDealVersions(Number(dealId));

      if (pricingDealVersions.error_status === 401) {
        setTokenExpired(true);
      }
      else if (pricingDealVersions.error_status === 403) {
        setNoAccess(true);
      }
      else {
        if (pricingDealVersions.error) {
          console.error('Error Response Data:', pricingDealVersions.error);
          console.error('Error Response Status:', pricingDealVersions.error_status);
          setError(normalizeErrorMessage(pricingDealVersions.error));
        }
      }

      const formatCurrency = (amount: number, currency: string): string => {
        try {
          return `${currencySymbolsMap[currency] || '$'} ${amount.toLocaleString('en-US', { minimumFractionDigits: 0 })}`;
        } catch (error) {
          console.error(error);
          return `${currencySymbolsMap[currency] || '$'} 0`;
        }
      };
      const dealEconomicsSummaries = pricingDealVersions.map((version: any) => ({
        'Blended Hourly Price': formatCurrency(version.blend_hourly_price ?? 0, version.currency),
        'Total Project Price': formatCurrency(version.total_project_price ?? 0, version.currency),
        'Project Discount Amount': formatCurrency(version.project_discount_amount ?? 0, version.currency),
        'Net Project Price': formatCurrency(version.net_project_price ?? 0, version.currency),
        'Total Project Labor Cost': formatCurrency(version.total_project_labor_cost ?? 0, version.currency),
        'Projected Client Margin %': `${version.project_client_margin ?? 0}%`,
        'Target Client Margin %': `${version.target_client_margin ?? 0}%`,
        'Variance to Target Margin': `${version.variance_to_target_margin ?? 0}%`,
        'Total Billable Hours': version.total_billable_hours ?? 0,
        'Updated By': version.updated_by,
        'Updated On': dayjs(version.updated_on).tz('America/New_York').format('MMM D, YYYY, h:mm:ss A z'),
        'ODE Status': version.ode_status
      }));

      const headerList = pricingDealVersions.map((version: any) => version.version_name);
      setDealAllVersionsEconomicsSummaries(dealEconomicsSummaries);
      setDealAllVersionsHeaderList(headerList);
    };
    const fetchPricingDealVersionCount = async () => {
      const pricingDealVersionCount = await getPricingDealVersionCount(Number(dealId));

      if (pricingDealVersionCount.error_status === 401) {
        setTokenExpired(true);
      }
      else if (pricingDealVersionCount.error_status === 403) {
        setNoAccess(true);
      }
      else {
        if (pricingDealVersionCount.error) {
          console.error('Error Response Data:', pricingDealVersionCount.error);
          console.error('Error Response Status:', pricingDealVersionCount.error_status);
          setError(normalizeErrorMessage(pricingDealVersionCount.error));
        }
      }

      setVersionCount(pricingDealVersionCount.version_count);
    };
    if (open) {
      fetchPricingDealVersionsData();
    }
    fetchPricingDealVersionCount();

  }, [dealId, open]);

  useEffect(() => {
    handleResourceAllocationCallback(ResourceFinalAllocationPlanData)
    if (discountValue === 0) {
      setDiscountRationale('')
    }
  }, [discountValue, contingencyValue]);

  useEffect(() => {
    if (HubspotDealData && HubspotDealData['Engagement Type'] === 'Fixed Fee') {
      if (!isDealVersionDetailsLoaded)
        setcontingencyValue(20)
    }
  }, [HubspotDealData]);

  useEffect(() => {
    if (monthlySummaryData.length > 0) {
      const dealEconomicsSummariesData: any[] = [{}];
      const dealEconomicsSummariesGrossNetData: any[] = [{}];
      const fieldNames = [`Project Revenue ${currencySymbol}`, `Project Labor Cost ${currencySymbol}`, `Projected Client Margin %`, `Target Client Margin %`, `Variance to Target`, `Blended Hourly Price`, `Blended Daily Price`];
      const contingencyAmount = Number((monthlySummaryData[0].total * (contingencyValue / 100)).toFixed(2));
      const discountAmount = Number(((Number(monthlySummaryData[0].total) + Number(contingencyAmount)) * (discountValue / 100)).toFixed(2));
      const costContingencyAmount = Number((monthlySummaryData[3].total * (contingencyValue / 100)).toFixed(2));
      const costDiscountAmount = Number(((Number(monthlySummaryData[3].total) + Number(costContingencyAmount)) * (discountValue / 100)).toFixed(2));
      fieldNames.forEach((fieldName, index) => {
        dealEconomicsSummariesGrossNetData[index] = {};
        //TO-DO: instead of array index use find method to get the particular value
        switch (fieldName) {
          case `Project Revenue ${currencySymbol}`:
            dealEconomicsSummariesGrossNetData[index]['key'] = index;
            dealEconomicsSummariesGrossNetData[index]['fieldName'] = fieldName;
            dealEconomicsSummariesGrossNetData[index]['gross'] = monthlySummaryData[0].total;
            dealEconomicsSummariesGrossNetData[index]['discount'] = Math.round(contingencyAmount - discountAmount);
            dealEconomicsSummariesGrossNetData[index]['net'] = Math.round(monthlySummaryData[0].total + (contingencyAmount - discountAmount));
            break;
          case `Project Labor Cost ${currencySymbol}`:
            dealEconomicsSummariesGrossNetData[index]['key'] = index;
            dealEconomicsSummariesGrossNetData[index]['fieldName'] = fieldName;
            dealEconomicsSummariesGrossNetData[index]['gross'] = monthlySummaryData[3].total;
            dealEconomicsSummariesGrossNetData[index]['discount'] = Math.round(costContingencyAmount);
            dealEconomicsSummariesGrossNetData[index]['net'] = Math.round(monthlySummaryData[3].total + (costContingencyAmount));
            break;
          case "Projected Client Margin %":
            dealEconomicsSummariesGrossNetData[index]['key'] = index;
            dealEconomicsSummariesGrossNetData[index]['fieldName'] = fieldName;
            dealEconomicsSummariesGrossNetData[index]['gross'] = monthlySummaryData[6].total;
            dealEconomicsSummariesGrossNetData[index]['discount'] = '';
            dealEconomicsSummariesGrossNetData[index]['net'] = dealEconomicsSummariesGrossNetData[0]['net'] != 0 ? (((dealEconomicsSummariesGrossNetData[0]['net'] - dealEconomicsSummariesGrossNetData[1]['net']) / dealEconomicsSummariesGrossNetData[0]['net']) * 100).toFixed(1) + '%' : '0%';
            break;

          case "Target Client Margin %":
            dealEconomicsSummariesGrossNetData[index]['key'] = index;
            dealEconomicsSummariesGrossNetData[index]['fieldName'] = fieldName;
            dealEconomicsSummariesGrossNetData[index]['gross'] = monthlySummaryData[7].total;
            dealEconomicsSummariesGrossNetData[index]['discount'] = '';
            dealEconomicsSummariesGrossNetData[index]['net'] = monthlySummaryData[7].total;
            break;
          case "Variance to Target":
            dealEconomicsSummariesGrossNetData[index]['key'] = index;
            dealEconomicsSummariesGrossNetData[index]['fieldName'] = fieldName;
            dealEconomicsSummariesGrossNetData[index]['gross'] = (parseFloat((monthlySummaryData[6].total).replace('%', '')) - parseFloat((monthlySummaryData[7].total).replace('%', ''))).toFixed(1) + '%';
            dealEconomicsSummariesGrossNetData[index]['discount'] = '';
            dealEconomicsSummariesGrossNetData[index]['net'] = (parseFloat(dealEconomicsSummariesGrossNetData[2]['net'].replace('%', '')) - parseFloat((monthlySummaryData[7].total).replace('%', ''))).toFixed(1) + '%';
            break;

          case "Blended Hourly Price":
            dealEconomicsSummariesGrossNetData[index]['key'] = index;
            dealEconomicsSummariesGrossNetData[index]['fieldName'] = fieldName;
            dealEconomicsSummariesGrossNetData[index]['gross'] =  monthlySummaryData[2].total == 0 ? 0 : Number((monthlySummaryData[0].total / monthlySummaryData[2].total).toFixed(2));
            dealEconomicsSummariesGrossNetData[index]['discount'] = '';
            dealEconomicsSummariesGrossNetData[index]['net'] = monthlySummaryDataAfterDiscount[2].total.replace(' hr', '') == 0 ? 0 : Number((dealEconomicsSummariesGrossNetData[0]['net'] / (monthlySummaryDataAfterDiscount[2]?.total ? monthlySummaryDataAfterDiscount[2].total.replace(' hr', '') : "0")).toFixed(2));
            break;
          case "Blended Daily Price":
            dealEconomicsSummariesGrossNetData[index]['key'] = index;
            dealEconomicsSummariesGrossNetData[index]['fieldName'] = fieldName;
            dealEconomicsSummariesGrossNetData[index]['gross'] = Number((dealEconomicsSummariesGrossNetData[5]['gross'] * 8).toFixed(2));
            dealEconomicsSummariesGrossNetData[index]['discount'] = '';
            dealEconomicsSummariesGrossNetData[index]['net'] = Number((dealEconomicsSummariesGrossNetData[5]['net'] * 8).toFixed(2));
            break;

        }

      });
      setDealEconomicsGrossNetSummaries(dealEconomicsSummariesGrossNetData)


      dealEconomicsSummariesData[0]["Blended Hourly Price"] = dealEconomicsSummariesGrossNetData[5]['net'];
      dealEconomicsSummariesData[0]["Total Project Price"] = monthlySummaryData[0].total;
      const contingencySummaryValue = dealEconomicsSummariesData[0]["Total Project Price"] * (contingencyValue / 100)
      dealEconomicsSummariesData[0]["Project Contingency Amount"] = Math.round(contingencySummaryValue);
      const discountSummaryValue = ((Number(dealEconomicsSummariesData[0]["Total Project Price"]) + Number(dealEconomicsSummariesData[0]["Project Contingency Amount"])) * (-1 * discountValue / 100))
      dealEconomicsSummariesData[0]["Project Discount Amount"] = Math.round(discountSummaryValue);
      dealEconomicsSummariesData[0]["Net Project Price"] = Math.round(((Number(dealEconomicsSummariesData[0]["Total Project Price"]) + Number(dealEconomicsSummariesData[0]["Project Contingency Amount"])) + discountSummaryValue));
      dealEconomicsSummariesData[0]["Total Project Labor Cost"] = monthlySummaryData[3].total;
      dealEconomicsSummariesData[0]["Projected Client Margin %"] = dealEconomicsSummariesGrossNetData[0]['net'] != 0 ? Number((((dealEconomicsSummariesGrossNetData[0]['net'] - dealEconomicsSummariesGrossNetData[1]['net']) / dealEconomicsSummariesGrossNetData[0]['net']) * 100).toFixed(1)) : 0;
      dealEconomicsSummariesData[0]["Target Client Margin %"] = parseFloat(monthlySummaryData[7].total.replace('%', ''));
      dealEconomicsSummariesData[0]["Variance to Target Margin %"] = Number((dealEconomicsSummariesData[0]["Projected Client Margin %"] - dealEconomicsSummariesData[0]["Target Client Margin %"]).toFixed(1));

      dealEconomicsSummariesData[0]["Projected Client Margin %"] = `${dealEconomicsSummariesData[0]["Projected Client Margin %"]} %`;
      dealEconomicsSummariesData[0]["Target Client Margin %"] = `${dealEconomicsSummariesData[0]["Target Client Margin %"]} %`;
      dealEconomicsSummariesData[0]["Variance to Target Margin %"] = `${dealEconomicsSummariesData[0]["Variance to Target Margin %"]} %`;
      setDealEconomicsSummaries(dealEconomicsSummariesData)
      // Calculate the discount amount based on the discount percentage on the total project price after contingency
      setDiscountAmount(Math.round(((Number(monthlySummaryData[0].total)+Number(monthlySummaryData[0].total)*(contingencyValue/100)) * ((discountValue ? discountValue : 0) / 100))))
    } else {
      setDealEconomicsGrossNetSummaries([])
      setDealEconomicsSummaries([])

    }
  }, [monthlySummaryData]);

  useEffect(() => {
    // Get all keys from ParticipantsAndRatesData
    const participantsKeys = ParticipantsAndRatesData.map(item => item.oldKey);

    // 1. Update existing ResourceAllocationPlanData if the role or other details have changed
    const updatedRecords = ResourceFinalAllocationPlanData.map(resource => {
      const matchingParticipant = ParticipantsAndRatesData.find(participant => participant.oldKey === resource.oldKey);

      if (matchingParticipant) {
        // Update the role or other fields if necessary
        const newRole = `${matchingParticipant.resourceType} - ${matchingParticipant.selectRegion} - ${matchingParticipant.serviceLineCapability} - ${matchingParticipant.selectLevel}`;
        if (resource.role !== newRole) {
          // Update the record if the role has changed
          return {
            ...resource,
            role: newRole,
            key: matchingParticipant.key,
            minFTE: matchingParticipant.minFTE
          };
        }
        return {...resource, key: matchingParticipant.key, minFTE: matchingParticipant.minFTE };
      }

      return resource;
    }).filter(resource => participantsKeys.includes(resource.oldKey));  // Remove records not in ParticipantsAndRatesData
    // 2. Find any new keys in ParticipantsAndRatesData that are not in ResourceAllocationPlanData
    const newRecords = ParticipantsAndRatesData.filter(participant =>
      !ResourceFinalAllocationPlanData.some(resource => resource.oldKey === participant.oldKey)
    ).map(participant => ({
      key: participant.key,  // Use the key from ParticipantsAndRatesData
      oldKey: participant.oldKey,
      role: `${participant.resourceType} - ${participant.selectRegion} - ${participant.serviceLineCapability} - ${participant.selectLevel}`,
      allocation: 100,
      startDate: startDate,
      endDate: getProjectEndDate(startDate, duration),
      duration: duration,
      months: {},
      name: '',
      comment: '',
      startDateWarning: false,
      endDateWarning: false,
      minFTE: participant.minFTE
    }));
    // 3. Combine updated records and new records
    const sortedRecords = [...updatedRecords, ...newRecords].sort((a, b) => a.key - b.key);
    setResourceAllocationPlanData(sortedRecords);

  }, [ParticipantsAndRatesData]);

  useEffect(() => {
    if (saveNewPricingVersion) {
      savePricingVersionDetails()
    }
    setSaveNewPricingVersion(false)
  }, [saveNewPricingVersion]);

  useEffect(() => {
    if (servicelineTotalRevenue && servicelineTotalRevenue.length > 0) {
      setUpdatedPricingItems(servicelineTotalRevenue.map(item => ({ name: item.service, amount: item.net })))
    }

  }, [servicelineTotalRevenue]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await getLatestLineItems(dealId);
      const pricingCalculatorVersionList = await getPricingCalculatorVersionList(dealId);
      if (result.error_status === 401 || pricingCalculatorVersionList.error_status === 401) {
        window.location.reload();
      } else {
        if (result.error || pricingCalculatorVersionList.error) {
          console.error('Error Response Data:', result.error, pricingCalculatorVersionList.error);
          console.error('Error Response Status:', result.error_status, pricingCalculatorVersionList.error_status);
          setError(normalizeErrorMessage(result.error ? result.error : pricingCalculatorVersionList.error));
          setLoader(false);
        } else {
          setDealTotalAmount(result["deal_amount"]);
          setLineItems(JSON.parse(JSON.stringify(result["hubspot_line_items"])));
          const mergeArrays = (lineItemList: any, pricingAppList: any) => {
            // Create a copy of pricingAppList with an added 'line_item_id: null' property for each object
            const mergedArray = pricingAppList.map((item: any) => ({ ...item, line_item_id: null }));

            lineItemList.forEach((item1: any) => {
              // Check if the name from lineItemList exists in the merged array
              const existingItemIndex = mergedArray.findIndex((item2: any) => item2.name === item1.name);

              if (existingItemIndex !== -1) {
                // If name exists, update the line_item_id in the existing object
                mergedArray[existingItemIndex] = { ...mergedArray[existingItemIndex], line_item_id: item1.line_item_id };
              } else {
                // If name does not exist, add the new object from lineItemList
                if (distinctServiceLines.includes(item1.name))
                  item1.amount = 0 // Set the amount to 0 for new items
                mergedArray.push(item1);
              }
            });

            return mergedArray;
          };
          let pricingAppLineItems = JSON.parse(JSON.stringify(updatedPricingItems));
          if(pricingCalculatorVersionList[0].line_item_type == 2){
            pricingAppLineItems = (() => {
              const contingency = pricingAppLineItems.find((lineItem:any) => lineItem.name === "Contingency");
              const contingencyAmount = contingency?.amount ?? 0;
              const totalWithoutContingency = pricingAppLineItems.filter((lineItem:any) => lineItem.name !== "Contingency").length > 0 ? pricingAppLineItems.filter((lineItem:any) => lineItem.name !== "Contingency").length : 1;
              return pricingAppLineItems
                .filter((lineItem:any) => lineItem.name !== "Contingency")
                .map((lineItem:any) => ({ ...lineItem, amount: lineItem.amount + (contingencyAmount/totalWithoutContingency) }));
            })();
          }
          const newUpdatedPricingItems = mergeArrays(result["hubspot_line_items"], pricingAppLineItems);
          setUpdatedPricingItems(newUpdatedPricingItems);
          setError(null);
          setLoader(false);
        }
      }
    }

    // if (newVersionNameModalVisible) {
    //   setLoader(true);
    //   fetchData();
    // };
  }, [newVersionNameModalVisible]);

  useEffect(() => {
    if(ParticipantsAndRatesData.length === 0){
      setDiscountValue(0)
      setDiscountAmount(0)
    }
  }, [ParticipantsAndRatesData]);

 
  const isAdmin = enabledFeatureList.includes("FE_ADMIN")
  const errorText = normalizeErrorMessage(error)

  const canNavigateToEdit = () => {
    if (!HubspotDealData) return false;
    return enabledFeatureList.includes('FE_EDIT_PRICING') && (!HubspotDealData['Locked Version Id'] || HubspotDealData['Locked Version Id'] == HubspotDealData['Version Id']);
  }

  return (
    <>
      {!viewOnly ? <FloatButton
        shape="square"
        type="primary"
        style={{ insetInlineEnd: 70, insetBlockEnd: 20, border: "1px solid rgb(255, 255, 255)", width: "120px" }}
        description={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <SaveOutlined style={{ fontSize: '22px', marginRight: '8px' }} />
            <span style={{ fontSize: '16px' }}>Save</span>
          </div>
        }
        tooltip={isDealLocked ? <div>Unlock to Update the Current Pricing Version</div> : <div>Click to Save Pricing</div>}
        // icon={<SaveOutlined />}
        badge={{ dot: true, color: `${(isDealLocked || !enabledFeatureList.includes('FE_EDIT_PRICING') || errorArray.length > 0) ? 'grey' : 'green'}` }}
        onClick={() => {
          if (isDealLocked) {
            message.error("Unlock deal to update")
            return
          }
          if (!enabledFeatureList.includes('FE_EDIT_PRICING')) {
            message.error("Unauthorised to update the deal")
            return
          }
          if (errorArray.length > 0) {
            message.error("Resolve the Error to update the deal")
            return
          }
          setVersionNameInputVisible(false);
          checkValidations();
          // setNewVersionNameModalVisible(true);
        }}
      /> : <FloatButton
        shape="square"
        type="primary"
        style={{ insetInlineEnd: 70, insetBlockEnd: 20, border: "1px solid rgb(255, 255, 255)", width: "120px"
        }}
        description={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <EditOutlined style={{ fontSize: '22px', marginRight: '8px' }} />
            <span style={{ fontSize: '16px' }}>Edit</span>
          </div>
        }
        tooltip={canNavigateToEdit() ? <div>Click to Edit Pricing</div> : enabledFeatureList.includes('FE_EDIT_PRICING') ? <div>ODE Locked on Another Version</div> : <div>No Access to Edit</div>}
        badge={{ dot: true, color: `${canNavigateToEdit() ? 'green' : 'grey'}` }}
        onClick={() => {
          if(canNavigateToEdit()) {
            navigate(`/edit-pricing-details?dealId=${dealId}&versionName=${encodeURIComponent(versionName)}`);
          }
        }}
    />}

      {!viewOnly && <FloatButton
        shape="square"
        type="default"
        style={{ insetInlineEnd: 20, insetBlockEnd: 20, border: "1px solid #4096ff" }}
        tooltip={isDealLocked ? <div>Unlock to Save as New Pricing version</div> : <div>Click to Save as New Pricing version</div>}
        icon={<DeliveredProcedureOutlined />}
        badge={{ dot: true, color: `${(isDealLocked || !enabledFeatureList.includes('FE_EDIT_PRICING') || errorArray.length > 0) ? 'grey' : 'green'}` }}
        onClick={() => {
          if (isDealLocked) {
            message.error("Unlock deal to save")
            return
          }
          if (!enabledFeatureList.includes('FE_EDIT_PRICING')) {
            message.error("Unauthorised to save the deal")
            return
          }
          if (errorArray.length > 0) {
            message.error("Resolve the Error to update the deal")
            return
          }
          setVersionNameInputVisible(true);
          checkValidations();
          // setNewVersionNameModalVisible(true);
        }}
      />}

      <FloatButton
        shape="square"
        type="default"
        onClick={() => setOpen(true)}
        style={{ insetInlineEnd: 20, insetBlockEnd: viewOnly ? 20 : 80, border: '1px solid #4096ff' }}
        badge={{ count: versionCount, color: '#4096ff' }}
        tooltip={<div>Click to compare pricing versions</div>}
      />

      {!viewOnly && <FloatButton
        shape="square"
        type="default"
        onClick={() => setCreateTemplateModalVisible(true)}
        style={{ insetInlineEnd: 20, insetBlockEnd: viewOnly ? 80 : 140, border: '1px solid #4096ff' }}
        icon={<CopyOutlined />}
        tooltip={<div>Create Template from This Version</div>}
      />}

    <FloatButton
        shape="square"
        type="default"
        onClick={() => setConfirmCancelOpen(true)}
        style={{ insetInlineEnd: 200, insetBlockEnd: 20, border: '1px solid #4096ff', width: '66px' }}
        tooltip={<div>Cancel and Go back to Home Page</div>}
        description={<div style={{paddingLeft: '8px', paddingRight: '8px'}}>Cancel</div>}
      />

      <Modal title={'Cancel and Go back to Home Page?'}
      open={confirmCancelOpen}
      onCancel={() => setConfirmCancelOpen(false)}
      onOk={() => navigate('/home')}
      closable={false} okText={'Confirm'}/>

      <CreateTemplateModal
        open={createTemplateModalVisible}
        dealId={dealId}
        versionName={versionName}
        isOldBasePricing={
          PricingVersion != null &&
          PricingVersion.length > 0 &&
          versionId !== [...PricingVersion].sort((a: any, b: any) => new Date(b.created_on).getTime() - new Date(a.created_on).getTime())[0]?.id
        }
        exampleResource={
          ParticipantsAndRatesData.length > 0
            ? `${ParticipantsAndRatesData[0].resourceType} - ${ParticipantsAndRatesData[0].selectRegion} - ${ParticipantsAndRatesData[0].serviceLineCapability} - ${ParticipantsAndRatesData[0].selectLevel}`
            : undefined
        }
        onClose={() => setCreateTemplateModalVisible(false)}
        onSuccess={(templateId, templateName) => {
          setCreateTemplateModalVisible(false);
          navigate(`/pricing-template?templateId=${templateId}&templateName=${encodeURIComponent(templateName)}`);
        }}
        onTokenExpired={() => setTokenExpired(true)}
      />

      {/* Drawer for Deal Economics Summaries */}
      <Drawer
        placement="right"
        onClose={() => setOpen(false)}
        open={open}
        mask={false} // Disabling the mask
      >
        <Row>
          <DealEconomicsSummaries dealId={dealId} dealEconomicsSummaries={dealAllVersionsEconomicsSummaries} headerList={dealAllVersionsHeaderList} enabledFeatureList={enabledFeatureList} span={24} />
        </Row>
      </Drawer>

      {noAccess ? <NoAccessPopup openPopup={true} popupMessage={'You do not have access to view pricing for this deal'}/>:
      tokenExpired ? <LogoutPopUp openPopup={tokenExpired} /> :
        <div>
          {errorText && <p className='text-danger'>Errors:<br></br> {errorText.includes(",") ? (
            errorText.split(",").map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))) : <>{errorText}</>}</p>}
          {errorText && !isDealLocked && (lockOde || isOdeLockRecovery) && (
            <Button type="primary" loading={retryingOdeLock} onClick={() => void retryOdeLock()}>
              Retry ODE lock
            </Button>
          )}
          {loading ? <LoadingOutlined style={{ fontSize: "40px", color: "cornflowerblue" }} /> :
            <>
              {(savePricingLoader || basePricingloader) &&
                <div
                  style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.7)', // Semi-transparent white
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999, // Ensure the loader is on top
                  }}
                >
                  <LoadingOutlined style={{ fontSize: "40px", color: "cornflowerblue" }} />
                </div>}

              <Modal
                title={<span className='text-danger'>HubSpot Data Issue!</span>}
                open={isRedirectToHome}
                onOk={() => handleDealRefresh()} // Redirect to home page
                onCancel={() => navigate('/home')}
                width={'50%'}
                cancelText={"Back to Home Page"}
                okText={"Refresh Deal"}
                confirmLoading={refreshingDeal}
              >
                <p><b>{fatalError}</b> , Please edit and save the valid values in HubSpot!</p>
                <p className='mt-3'></p>
                <p className='mt-3'>Click <b>Refresh Deal</b> after HubSpot Changes or <b>Cancel</b> to redirect to home page</p>
              </Modal>

              <Modal
                title={<span className='text-danger'>HubSpot Deal Details Changed!</span>}
                open={isHubspotFieldsChanged}
                onCancel={() => setIsHubspotFieldsChanged(false)}
                 footer={null}
                width={'50%'}
              >
                <p>The following HubSpot deal details have changed after pricing version was created:</p>
                <strong>Fields Changed:</strong>
                <HubspotFieldsChangeTable dataSource={hubspotFieldsChangedArray} />
                <p className='mt-3'>Click <b>Refresh Deal</b> after HubSpot Changes or <b>Continue</b> to confirm current change</p>
                <div style={{display: 'flex', gap: '8px', justifyContent: 'end'}}> <Button onClick={() => handleDealRefresh()}>Refresh Deal</Button> <Button onClick={() => setIsHubspotFieldsChanged(false)} type="primary">Continue</Button></div>
              </Modal>

              <Modal
                title={requestODELock ? <span>Lock Pricing Version as ODE?</span> : <span>Save Pricing Version</span>}
                open={newVersionNameModalVisible}
                confirmLoading={loader}
                onOk={() => {
                  if (!error) {
                    if (versionNameInputVisible) {
                      if (!newVersionName.trim()) {
                        setErrorMessage('Version name cannot be empty.');
                        return;
                      }
                      setVersionName(newVersionName.trim())
                    }
                    setNewVersionNameModalVisible(false)
                    setSaveNewPricingVersion(true)
                    setReloadNavigation(true)
                    setRequestODELock(false)
                  } else {
                    setNewVersionNameModalVisible(false)
                    setRequestODELock(false)
                  }
                }}
                onCancel={() => {
                  setErrorMessage('');
                  setRequestODELock(false)
                  setNewVersionNameModalVisible(false)
                }}
                width={'70%'}
              >
                {error && <p className='text-danger'>Error: {error}</p>}

                {!error &&
                  <div className='pt-2 ps-2' style={{ border: "1px solid #80808017" }}>
                    {versionNameInputVisible ? (
                      <>
                        <label htmlFor="versionName">Enter New Version Name:</label>
                        <Input id="versionName" onChange={(e: any) => setNewVersionName(e.target.value)} value={newVersionName} />
                      </>
                    ) : null}
                    {ParticipantsAndRatesData.length > 0 ?
                      <>
                        <Checkbox
                          checked={lockOde}
                          onChange={(e) => {
                            setlockOde(e.target.checked)
                            // setSendHubspotLineItems(e.target.checked)
                            setUpdateHubspotDealAmount(e.target.checked)
                            setSendEmail(e.target.checked)
                          }}
                          className='mb-3'
                          style={{ marginTop: '16px' }}
                          disabled={requestODELock ? true : enabledFeatureList.includes('FE_LOCK_ODE') ? false : true}
                        >
                          Lock Pricing Version as ODE
                        </Checkbox>
                        {lockOde ? <p style={{marginTop: '8px'}}><strong>Note:</strong> Once a deal is locked with ODE, <strong>you will no longer be able to edit any pricing version</strong>. If changes are needed after locking, you must unlock ODE by clicking the <strong>"ODE Unlock"</strong> button at the top-right corner of the Pricing page. If the deal is in <strong>Stage 7</strong> or includes <strong>WAC</strong>, unlocking will require an <strong>admin request</strong>.  Otherwise, you can unlock ODE yourself and resubmit and relock the pricing version.</p> : <br/>}
                        {/* <Checkbox
                          checked={sendHubspotLineItems}
                          onChange={(e) => setSendHubspotLineItems(e.target.checked)}
                          className='mb-3'
                          style={{ marginTop: '16px' }}
                          disabled={requestODELock ? true : enabledFeatureList.includes('FE_SUBMIT_LINE_ITEMS') ? lockOde ? isAdmin ? false : true : false : true}
                        >
                          Upload Line Items to HubSpot
                        </Checkbox> */}
                        <Checkbox
                          checked={updateHubspotDealAmount}
                          onChange={(e) => setUpdateHubspotDealAmount(e.target.checked)}
                          className='mb-3'
                          style={{ marginTop: '16px' }}
                          disabled={requestODELock ? true : enabledFeatureList.includes('FE_SUBMIT_LINE_ITEMS') ? lockOde ? isAdmin ? false : true : false : true}
                        >
                          Update Deal Amount in HubSpot
                        </Checkbox>
                        {/* {sendHubspotLineItems && (loader ? <><br></br><Spin /></> :
                        <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                          <div className="mb-2" style={{display: 'flex', flexDirection: 'column', gap: '3px', marginTop: '3px', marginLeft: '4px'}}>
                            <strong>By confirming, the following line items will be automatically updated in HubSpot</strong>
                          </div>
                          <LineItemCompareTable dataSrc={servicelineTotalRevenue} totalDealAmount={dealTotalAmount} distinctServiceLines={distinctServiceLines} hubspotLineItems={lineItems as LineItem[]} updatedPricingItems={updatedPricingItems} handleAmountChange={handleAmountChange} />
                        </div>
                        )
                        } */}
                        <br></br>
                        <Checkbox
                          checked={sendEmail}
                          onChange={(e) => setSendEmail(e.target.checked)}
                          className='mb-3'
                          style={{ marginTop: '16px' }}
                          disabled={requestODELock ? true : enabledFeatureList.includes('FE_SEND_RESOURCE_REQUEST') ? lockOde ? isAdmin ? false : true : false : true}
                        >
                          Send Resource Request

                        </Checkbox>

                        {sendEmail && (
                        <><br/><b>By confirming, a notification will be sent{lockOde && " with the ODE status included"}.</b>
                        <br/></>)}
                        <br/>
                        <b>Note: Project ODE Client Margin ({currencySymbol}/%) reflects only Americas Non-IS and Non-Data Line Items.</b>
                        <br></br>
                      </> :
                      <div>Do you want to save the pricing version?</div>
                    }
                    {/* {sendEmail && <ResourceAllocationPlan dataSource={ResourceFinalAllocationPlanData} onChange={handleResourceAllocationCallback} monthColumns={monthColumns} duration={duration} startDate={startDate} endDate={endDate} isEditable={false} />} */}

                    {errorMessage && (
                      <div style={{ color: 'red', marginTop: '16px' }}>
                        {errorMessage}
                      </div>
                    )}
                  </div>
                }
              </Modal>
              <ResourceRequestMappingModal
                open={resourceMappingModalOpen}
                preview={resourceRequestPreview}
                confirmLoading={savePricingLoader}
                onCancel={() => {
                  setResourceMappingModalOpen(false)
                  setResourceRequestPreview(null)
                }}
                onConfirm={(confirmation) => {
                  setResourceMappingModalOpen(false)
                  savePricingVersionDetails(confirmation)
                }}
              />
              <Modal
                title={<span><CheckCircleOutlined style={{ color: 'green' }} /> Success</span>}
                open={isSuccessModalVisible}
                onOk={() => {
                  setIsSuccessModalVisible(false)
                  if (reloadNavigation) {
                    navigate(`/edit-pricing-details?dealId=${dealId}&versionName=${encodeURIComponent(versionName)}`);  // Navigate to /edit-pricing page
                    setReloadNavigation(false)
                    window.location.reload();
                  }
                }}
                onCancel={() => {
                  setIsSuccessModalVisible(false)
                  if (reloadNavigation) {
                    navigate(`/edit-pricing-details?dealId=${dealId}&versionName=${encodeURIComponent(versionName)}`);  // Navigate to /edit-pricing page
                    setReloadNavigation(false)
                    window.location.reload();
                  }
                }}
              >
                {lockOde ? <p>Pricing version saved and locked as ODE.</p> : sendHubspotLineItems || showHubspotLineItemsUpdatedMessage ? <p>Line Items updated successfully to HubSpot.</p> : <p>Pricing version saved successfully.</p>}
              </Modal>
              <DealInsights dataSource={dealEconomicsSummaries} minFTEWarning={minFTEWarning} />
              <HubSpot disableForm={false} hubSpotData={HubspotDealData} pricingContributors={PricingContributors} onChange={handleBasePricingChange} versionName={versionName} pricingVersion={PricingVersion} pricingCollaborators={pricingCollaborators} onUpdatedVersionName={handleVersionNameUpdate} isDealLocked={isDealLocked} setDealLock={setIsDealLocked} enabledFeatureList={enabledFeatureList} setSaveNewPricingVersion={setSaveNewPricingVersion} setlockOde={setlockOde} setSendEmail={setSendEmail} lineItemData={servicelineTotalRevenue} dealId={dealId} distinctServiceLines={distinctServiceLines} setReloadNavigation={setReloadNavigation} viewOnly={viewOnly} basePricingVersionId={versionId} lastRefreshedOn={dealLastRefreshedOn} handleODELockAsSave={handleODELockAsSave}/>
              {!viewOnly && !isDealLocked && enabledFeatureList.includes('FE_EDIT_PRICING') && <>
                {copyResourcesOpen && <ResourceImportModal dealId={dealId} start={startDate} end={endDate} duration={duration} rates={pricingCalculatorDetails ?? []}
                    basePriceVersionId={versionId} pricingVersions={PricingVersion}
                    firstKey={Math.max(0, ...ParticipantsAndRatesData.map(r => r.oldKey)) + 1}
                    onClose={() => setCopyResourcesOpen(false)} onApply={({ participants, allocations }, replace) => {
                      const newParticipants = [...(replace ? [] : ParticipantsAndRatesData), ...participants].map((r, i) => ({ ...r, key: i + 1 }));
                      const newAllocations = [...(replace ? [] : ResourceFinalAllocationPlanData), ...allocations].map((r, i) => ({ ...r, key: i + 1 }));
                      setResourceFinalAllocationPlanData(newAllocations);
                      setResourceAllocationPlanData(newAllocations);
                      setParticipantsAndRatesInitialData(newParticipants);
                      setParticipantsAndRatesData(newParticipants);
                      message.success('Resources added. Review the dates and allocations, then save the version.');
                    }} />}
              </>}
              <ParticipantsAndRates dataSource={ParticipantsAndRatesInitialData} onChange={handleParticipantsAndRatesCallback} pricingCalculatorDetailsData={pricingCalculatorDetails} viewOnly={viewOnly} pipelineName={pipelineName} hoveredRowKey={hoveredRowKey} onRowHover={setHoveredRowKey}
                onCopyResources={!viewOnly && !isDealLocked && enabledFeatureList.includes('FE_EDIT_PRICING') ? () => setCopyResourcesOpen('deal') : undefined}
                onSearchEmployees={!viewOnly && !isDealLocked && enabledFeatureList.includes('FE_EDIT_PRICING') ? () => setCopyResourcesOpen('employee') : undefined} />
              <div id="resource-allocation-section">
                <ResourceAllocationPlan dataSource={ResourceAllocationPlanData} onChange={handleResourceAllocationCallback} monthColumns={monthColumns} duration={duration} startDate={startDate} endDate={endDate} viewOnly={viewOnly} additionalResourcingInfo={additionalResourcingInfo} setAdditionalResourcingInfo={setAdditionalResourcingInfo} setMinFTEWarning={setMinFTEWarning} hoveredRowKey={hoveredRowKey} onRowHover={setHoveredRowKey} />
              </div>
              <NonResourceCosts dataSource={nonResourceInitialData} onChange={handleNonResourceCallback} nonResourcePricingDetailsData={nonResourcePricingDetails} startDate={startDate} endDate={endDate} viewOnly={viewOnly} />
              <ProjectRevenue title="Deal Revenue and Cost Details" dataSource={revenueData} monthColumns={monthColumns} duration={duration} startDate={startDate} />
              <SummaryTable title="Total Monthly Summary Before Adjustments" dataSource={monthlySummaryData} monthColumns={monthColumns} />

              {/* Fixed-Fee Project Contingency Section */}
              {(!isDealLocked && HubspotDealData && HubspotDealData['Engagement Type'] === 'Fixed Fee') ||
               (HubspotDealData && HubspotDealData['Pricing Version Engagement Type'] === 'Fixed Fee' && isDealLocked) ? (
                <Card title="Fixed-Fee Project Contingency" style={{ marginBottom: '16px' }}>
                  <div className='mb-4'>
                    <Badge status="default" style={{ marginRight: "5px" }} text="Contingency:" />
                    <InputNumber
                      min={0}
                      max={100}
                      value={contingencyValue}
                      formatter={(value) => `${value} %`}
                      onChange={(value) => setcontingencyValue(value ? value : 0)}
                      style={{ width: 100, borderColor: 'blue', marginRight: '10px' }}
                      className="bold-input"
                      disabled={viewOnly}
                    />
                    <Tooltip title={<span dangerouslySetInnerHTML={{ __html: getTooltip("Contingency") || '' }} />}>
                      <InfoCircleOutlined style={{ marginLeft: "10px", marginTop: "2px", color: "#4096FF" }} />
                    </Tooltip>
                  </div>
                </Card>
              ) : null}

              {/* Adjustments Section */}
              <Card title={<>Adjustments<Tooltip title={<span dangerouslySetInnerHTML={{ __html: getTooltip("Discount and Contingency") || '' }} />}><InfoCircleOutlined style={{ marginLeft: "10px", marginTop: "2px", color: "#4096FF" }} /></Tooltip></>} style={{ marginBottom: '16px' }}>
                {/* Gross Revenue section after contingency*/}
                <div className='mb-4'>
                  <Badge status="default" style={{ marginRight: "5px" }} text="Gross Revenue:" />
                  <InputNumber
                    prefix={currencySymbol}
                    value={dealEconomicsSummaries.length > 0 ? Math.round(dealEconomicsSummaries[0]["Total Project Price"] + dealEconomicsSummaries[0]["Total Project Price"]*contingencyValue/100) : 0}
                    style={{ width: 150, borderColor: 'blue' }}
                    className="bold-input"
                    disabled={true}
                  />
                </div>

                {/* Discount section with percentage and amount in one line */}
                <div className='mb-4' style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Badge status="default" style={{ marginRight: "5px" }} text="Discount/Round Up (%):" />
                    {/* Discount percentage input field with validation (-100% to 100%) */}
                    <InputNumber
                      min={-100}
                      max={100}
                      value={discountValue}
                      suffix="%"
                      onChange={(value) => {
                        changeDiscountValue(value, setDiscountValue, setDiscountAmount, dealEconomicsSummaries, contingencyValue)
                      }}
                      style={{ width: 100, borderColor: 'blue' }}
                      className="bold-input"
                      disabled={viewOnly || dealEconomicsSummaries.length < 1}
                    />
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {/* Label for discount amount field */}
                    <Badge status="default" style={{ marginRight: "5px" }} text={`Discount/Round Up (${currencySymbol}):`} />
                    {/* Discount amount input field in currency */}
                    <InputNumber
                      prefix={currencySymbol}
                      value={discountAmount}
                      onChange={(value) => {
                        changeDiscountAmount(value, setDiscountValue, setDiscountAmount, dealEconomicsSummaries, contingencyValue)
                      }}
                      style={{ width: 100, borderColor: 'blue' }}
                      className="bold-input"
                      disabled={viewOnly || dealEconomicsSummaries.length < 1}
                    />
                  </div>
                  {/* Rationale dropdown - only shown when discount is applied */}
                  {discountValue !== 0 && (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Badge status="error" style={{ marginRight: "5px" }} text="Rationale:" />
                      <Select
                        style={{ width: '15rem' }}
                        disabled={viewOnly}
                        onChange={(value) => setDiscountRationale(value)}
                        status={discountValue !== 0 && discountRationale == '' ? "error" : ""}
                        value={discountRationale}>
                        {/* Different options for positive discount vs round up */}
                        {discountValue > 0 ? (
                          <>
                            <option value={''}>Select Rationale</option>
                            {(discountRationaleDD && discountRationaleDD.length > 0) &&
                              discountRationaleDD.filter((filterItem: any) => !filterItem.reason.includes('Roundup')).map((item: any) => <option key={item.reason} value={item.reason}>{item.reason}</option>)
                            }
                          </>
                        ) : <>
                            <option value={''}>Select Rationale</option>
                            {(discountRationaleDD && discountRationaleDD.length > 0) &&
                              discountRationaleDD.filter((filterItem:any) => filterItem.reason.includes('Roundup')).map((item: any) => <option key={item.reason} value={item.reason}>{item.reason}</option>)
                            }
                        </>}
                      </Select>
                    </div>
                  )}
                </div>
                <p className='mt-2'><i>Enter a negative discount number to round up</i></p>

                {/* Net Revenue section */}
                <div className='mb-4'>
                  <Badge status="default" style={{ marginRight: "5px" }} text="Net Revenue:" />
                  <InputNumber
                    min={0}
                    max={dealEconomicsSummaries.length > 0 ? Math.round(dealEconomicsSummaries[0]["Total Project Price"] + dealEconomicsSummaries[0]["Total Project Price"]*contingencyValue/100)*2 : 0} // double of gross revenue
                    prefix={currencySymbol}
                    value={dealEconomicsSummaries.length > 0 ? dealEconomicsSummaries[0]["Net Project Price"] : 0}
                    onChange={(value) => {
                      changeTotalAmount(value, setDiscountValue, setDiscountAmount, dealEconomicsSummaries, contingencyValue)
                    }}
                    style={{ width: 150, borderColor: 'blue' }}
                    className="bold-input"
                    disabled={viewOnly || dealEconomicsSummaries.length < 1}
                  />
                  <Tooltip title={<span dangerouslySetInnerHTML={{ __html: getTooltip("Net Revenue") || '' }} />}>
                    <InfoCircleOutlined style={{ marginLeft: "10px", marginTop: "2px", color: "#4096FF" }} />
                  </Tooltip>
                </div>

              </Card>
              <SummaryTable title="Total Monthly Summary After Adjustments" dataSource={monthlySummaryDataAfterDiscount} monthColumns={monthColumns} />
              <RevenueSummary dataSrc={servicelineTotalRevenue} dealId={dealId} setSaveNewPricingVersion={setSaveNewPricingVersion} setReloadNavigation={setReloadNavigation} isDealLocked={isDealLocked} enabledFeatureList={enabledFeatureList} distinctServiceLines={distinctServiceLines} setSendHubspotLineItems={setShowHubspotLineItemsUpdatedMessage} versionId={HubspotDealData?.['Version Id']} versionName = {versionName}/>
              <DealEconomicsSummariesDetails dataSource={dealEconomicsSummaries} grossNetDataSource={dealEconomicsGrossNetSummaries} totalBillableHours={monthlySummaryDataAfterDiscount[2]?.total ? monthlySummaryDataAfterDiscount[2].total.replace(' hr', '') : "0"} onChange={handledealEconomicsFinalData} targetMarginDD={targetMarginDD ?? []} initialDealPricingComment={dealPricingComment ?? ''} initialbelowTargetMarginReason={belowTargetMarginReason ?? ''} span={24} viewOnly={viewOnly} />
            </>
          }
        </div>
      }
    </>
  );
};

export default EditPricingDetails;
